import React from "react";
import * as Modal from "react-modal";
// import { confirmAlert } from 'react-confirm-alert';
import moment from "moment";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-confirm-alert/src/react-confirm-alert.css";
import AppBar from "@material-ui/core/AppBar";
import Tab1 from "@material-ui/core/Tab";
import TabContext1 from "@material-ui/lab/TabContext";
import TabList1 from "@material-ui/lab/TabList";
import TabPanel1 from "@material-ui/lab/TabPanel";
import LinkAccountStep1 from "../../components/profile/linkAccountStepOne.js";
import LinkAccountStep2 from "../../components/profile/linkAccountStepTwo.js";
import LinkCardStep2 from "../../components/profile/linkCardStepTwo.js";
import CardInputMaskinking from "../common/cardInputMaskinking";
import CardInputField from "../common/cardInputField";
import DownloadPdfFile from "./downloadPDFFile";
import {
  ToastsContainer,
  ToastsStore,
  ToastsContainerPosition,
} from "react-toasts";
import {
  Icon,
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
} from "@material-ui/core";
import Validator from "validator";
import Dropdown from "react-dropdown";
import "react-dropdown/style.css";
import isEmpty from "lodash/isEmpty";
import { bindActionCreators } from "redux";
import { withAlert } from "react-alert";
import { connect } from "react-redux";
import * as _ from "lodash";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import lockImage from "../../images/lock.png";
// import { Auth } from 'aws-amplify';
import "react-phone-number-input/style.css";
import "react-responsive-ui/style.css";
import LinkAccountAddress from "../../components/profile/linkAccountAddress.js";
import LinkCardAccountAddress from "../../components/profile/linkCardAccountAddress.js";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import "react-toastify/dist/ReactToastify.css";
import Tooltip from "@material-ui/core/Tooltip";
import ChangePassword from "../common/changePassword";
import MaskInputNumber from "../common/maskInputNumberProfile";
import { CSVLink,} from "react-csv";
import {
  uploadfile,
  getAllCountry,
  getConsumerUser,
  updateConsumerUser,
  saveResidences,
  getAllStates,
  getTranscardPaymentMethods,
  getConsumerUserResidenceAction,
  deleteResidencesData,
  viewResidencesData,
  clearDataEmail,
  checkEmailVerify,
  getDebitWalletBalance,
  createTranscardAccount,
  createTranscardCard,
  addUserBankAccount,
  addUserCard,
  disbursePayment,
  transferFundsToACH,
  transferFundsToCard,
  clearReceiveAddUserBankAccountApi,
  clearReceiveAddUserCard,
  getAddedBankAccountsForUser,
  getAddedCardsForUser,
  getCollectedSettlementsHistoryForUser,
  getUserTransactionsHistory,
  setDefaultBankAccount,
  setDefaultCard,
  deleteUserBankAccount,
  deleteUserCard,
  showNetAmountToUser,
  clearRecieveDisburseAmount,
  clearReceiveTransferFundsToACH,
  clearReceiveTransferFundsToCard,
  cleargetDebitWalletBalance,
  updateBankAccountDetails,
  updateCardDetails,
  getAllBankAccountsForUser,
  getAllAddedCardsForUser,
  clearReceiveUpdateBankAccountDetails,
  clearReceiveUpdateCardDetails,
} from "../../Actions/actions";
import CustomSignature from "../common/signatureComponent";
import Vehicles from "../common/addVehicle";
import TextFieldGroup from "../common/TextFieldGroupProfile";
import loader from "../../images/Spin-1s-107px.gif";
import transcard from "../../images/transcard.png";
import BannerHead from "../BannerHead";
import TextFieldGroupProfile from "../common/TextFieldGroupProfile";

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    overflow: "hidden",
    width: "60%",
    maxWidth: "460px",
    height: "654px",
    padding: "0",
    border: "none",
  },
};
const customStylesCardDetails = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    overflow: "hidden",
    width: "60%",
    maxWidth: "460px",
    height: "450px",
    padding: "0",
    border: "none",
  },
};
const customStylesConfirmationPopup = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    overflow: "hidden",
    width: "60%",
    maxWidth: "460px",
    minHeight: "307px",
    padding: "0",
    border: "none",
  },
};
const customEditStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    overflow: "hidden",
    width: "60%",
    maxWidth: "460px",
    height: "auto",
    padding: "0",
    border: "none",
  },
};
const linkedAccCustomStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    overflow: "hidden",
    width: "60%",
    maxWidth: "700px",
    height: "550px",
  },
};
const customStylesTransferType = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    overflow: "hidden",
    width: "60%",
    maxWidth: "unset",
    height: "370px",
    padding: "0",
    border: "0",
    width: "460px",
  },
};
const customStylesDisburse = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    overflow: "hidden",
    width: "60%",
    maxWidth: "unset",
    height: "490px",
    padding: "0",
    border: "0",
    width: "460px",
  },
};

class Profile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tableState : false ,
      cFirstName: "",
      cLastName: "",
      cState: "",
      rState: "",
      cEmployer: "",
      cEmail: "",
      oldEmail: "",
      modalIsDebite: false,
      email: "",
      cPhone: "",
      cPassword: "",
      cNotification: "",
      cUpdateClaim: "",
      errors: {},
      cognitoClientId: "",
      isLoading: false,
      roleName: "Consumer",
      readDisclaimer: "",
      readPrivacyPolicy: "",
      readLetterOfAgency: "",
      readUserAgreement: "",
      cDefaultOption: "",
      cSince: "",
      stateSuccess: [],
      modalIsOpen: false,
      modalIsOpenVehicle: false,
      modalIsOpenResidences: false,
      saveAddress: false,
      file: "",
      updateImage: true,
      cCountryCode: "+1",
      consumerResidences: [],
      showUpadeButtonR: false,
      showSaveButtonR: false,
      rSinceFrom: "",
      primaryFlag: "N",
      rSinceTo: "",
      userId: localStorage.getItem("userId"),
      userResidenceId: "",
      updateResidence1: "",
      deleteResidenceData1: [],
      saveResidence1: "",
      errorsResidence: {},
      ConsumerUpdateProfileDataStatus: false,
      ConsumerUpdateProfileData1: [],
      signatureDefaultValue: "",
      signatureFontFamily: "",
      privacyPolicyPath: "",
      agreementLetterPath: "",
      letterOfAgencyPath: "",
      intervalId: 0,
      linkAccountStep1: false,
      linkCardAccountStep1: false,
      addAccountStep1: false,
      addCardAccountStep1: false,
      value: "1",
      cardValue: "1",
      checkboxState: false,
      errorCheckbox: true,
      routingNumber: "",
      accountNumber: "",
      accountType: "",
      accountHolderName: "",
      displayName: "",
      createAccEnable: false,
      transcardAccountState: false,
      accountHolderNameError: "",
      accountNumberError: "",
      routingNumberError: "",
      displayNameError: "",
      showLinkButton: false,
      disburseAmountPopupState: false,
      transferFundsToACHState: false,
      transferFundsToCardState: false,
      debitWalletBalanceState: false,
      addUserBankAccountState: false,
      addUserCardState: false,
      addMultipleAccountState: false,
      isCreated: false,
      isCreatedCard: false,
      viewAccountState: false,
      address1Popup: "",
      address2Popup: "",
      cityPopup: "",
      zipPopup: "",
      statePopup: "",
      address1PopupError: "",
      statePopupError: "",
      address2PopupError: "",
      cityPopupError: "",
      zipPopupError: "",
      transcardCardState: false,
      address1CardPopup: "",
      address2CardPopup: "",
      cityCardPopup: "",
      zipCardPopup: "",
      stateCardPopup: "",
      address1CardPopupError: "",
      stateCardPopupError: "",
      address2CardPopupError: "",
      cityCardPopupError: "",
      zipCardPopupError: "",
      stateCardPopupName: "",
      cardAlreadyLinked: false,
      nextButtonStepActive: false,
      nextCardButtonStepActive: false,
      statePopupName: "",
      addressNextButton: false,
      addressCardNextButton: false,
      openEditModel: false,
      bankName: "",
      bankId: "",
      cardId: "",
      errorbankName: false,
      errorCardName: false,
      updateBankButton: true,
      paymentHistoryState: {},
      AddNewBankAccountState: false,
      radioAddedAccountChecked: false,
      radioAccountValue: "",
      radioCardValue: "",
      addNewAccWithoutAdd: "",
      addNewCardWithoutAdd: "",
      noAccountLinked: false,
      showDeleteConfirmation: false,
      hasAnyActiveAccount: false,
      hasAnyActiveCard: false,
      userHasNoAccounts: false,
      userHasNoCards: false,
      noCardLinked: false,
      accountTypePopupState: false,
      instantTransferState: false,
      achState: false,
      cardLastName: "",
      cardFirstName: "",
      cardNickName: "",
      cardErrors: {
        cardMonthError: true,
        cardNumberError: true,
      },

      cardErrorsState: {
        cardMonthError: true,
        cardNumberError: true,
      },
    };
    this.onChange = this.onChange.bind(this);
    this._cSelect = this._cSelect.bind(this);
    this._rSelect = this._rSelect.bind(this);
    this._cSince1 = this._cSince1.bind(this);
    this._cSince2 = this._cSince2.bind(this);

    this.handleSubmitConsumer = this.handleSubmitConsumer.bind(this);
    this.handleSubmitResidences = this.handleSubmitResidences.bind(this);
    this.handleUpdateResidences = this.handleUpdateResidences.bind(this);
    this.handleSeletcedYearChangeConsumer = this.handleSeletcedYearChangeConsumer.bind(
      this
    );
    this.openModal = this.openModal.bind(this);
    this.openModalResidences = this.openModalResidences.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.closeModalResidences = this.closeModalResidences.bind(this);
    this.uploadSignature = this.uploadSignature.bind(this);
    this._cCountrySelect = this._cCountrySelect.bind(this);
  }

  sigPad = {};

  clear = () => {
    this.sigPad.clear();
  };

  /**
   * Fetch Image from signature
   */
  trim = () => {
    const { cFirstName, cLastName, cEmail } = this.state;
    if (this.sigPad.isEmpty() === false) {
      this.props.uploadfile({
        image: this.sigPad.getTrimmedCanvas().toDataURL("image/png"),
        firstName: cFirstName,
        lastName: cLastName,
        email: cEmail,
        streeAddress: "",
      });
      this.setState({
        file: this.sigPad.getTrimmedCanvas().toDataURL("image/png"),
      });
    }
    this.closeModal();
  };

  handleSaveCard = (e) => {
    let cardExpirationDate = `20${this.state.cardYear}-${this.state.cardMonth}`;
    e.preventDefault();
    const data = {
      userId: localStorage.getItem("userId"),
      cvc: this.state.cardCvv,
      firstName: this.state.cardFirstName,
      lastName: this.state.cardLastName,
      cardNickName: this.state.cardNickName,
      cardNumber: this.state.cardNumber.replace(/_/g, "").replace(/ /g, ""),
      cardExpirationDate: cardExpirationDate,
    };
    this.props.addUserCard({ data });
  };

  // Validate Card Details

  onChangeCarad = (e) => {
    let labelName = e.target.name;
    this.setState(
      {
        [e.target.name]: e.target.value.trimLeft(),
      },
      () => {
        this.isValidCardDetail(labelName);
      }
    );
  };

  isValidCardDetail(label) {
    const { errors, errorsState, isValid } = this.validateInputCard(
      this.state,
      label
    );
    // console.log('errors')
    // if (!isValid) {
    this.setState({ cardErrors: errors, cardErrorsState: errorsState });
    // }
    return isValid;
  }

  validateInputCard(data, label) {
    const { cardErrorsState } = this.state;
    const errors = cardErrorsState;
    const d = new Date();

    // const scrollViews = [];
    switch (label) {
      case "cardNumber":
        if (Validator.isEmpty(data.cardNumber)) {
          errors.cardNumber = "Card Number is required";
          errors.cardNumberError = true;
        } else if (
          data.cardNumber.replace(/_/g, "").replace(/ /g, "").length < 15
        ) {
          errors.cardNumber =
            "Card Number should consist of min 15 and max 16 characters";
          errors.cardNumberError = true;
        } else {
          errors.cardNumber = "";
          errors.cardNumberError = false;
        }
        break;

      case "cardFirstName":
        if (Validator.isEmpty(data.cardFirstName)) {
          errors.cardFirstName = "First Name is required";
          errors.cardFirstNameError = true;
        } else if (
          data.cardFirstName.length < 2 ||
          data.cardFirstName.length > 20
        ) {
          errors.cardFirstName =
            "First name should consist of min 2 and max 20 characters";
          errors.cardFirstNameError = true;
        } else {
          errors.cardFirstName = "";
          errors.cardFirstNameError = false;
        }
        break;
      case "cardNickName":
        if (Validator.isEmpty(data.cardNickName)) {
          errors.cardNickName = "Nick Name is required";
          errors.cardNickNameError = true;
        } else if (
          data.cardNickName.length < 2 ||
          data.cardNickName.length > 20
        ) {
          errors.cardNickName =
            "Nick name should consist of min 2 and max 20 characters";
          errors.cardNickNameError = true;
        } else {
          errors.cardNickName = "";
          errors.cardNickNameError = false;
        }
        break;
      case "cardLastName":
        if (Validator.isEmpty(data.cardLastName)) {
          errors.cardLastName = "Last Name is required";
          errors.cardLastNameError = true;
        } else if (
          data.cardLastName.length < 2 ||
          data.cardLastName.length > 20
        ) {
          errors.cardLastName =
            "Last name should consist of min 2 and max 20 characters";
          errors.cardLastNameError = true;
        } else {
          errors.cardLastName = "";
          errors.cardLastNameError = false;
        }
        break;
      case "cardAddress":
        if (Validator.isEmpty(data.cardAddress)) {
          errors.cardAddress = "Address is required";
          errors.cardAddressError = true;
        } else if (
          data.cardAddress.length < 2 ||
          data.cardAddress.length > 50
        ) {
          errors.cardAddress =
            "Street address should consist of min 2 and max 50 characters ";
          errors.cardAddressError = true;
        } else {
          errors.cardAddress = "";
          errors.cardAddressError = false;
        }
        break;
      case "cardCity":
        if (Validator.isEmpty(data.cardCity)) {
          errors.cardCity = "City is required";
          errors.cardCityError = true;
        } else if (data.cardCity.length < 2 || data.cardCity.length > 30) {
          errors.cardCity =
            "City should consist of min 2 and max 30 characters";
          errors.cardCityError = true;
        } else {
          errors.cardCity = "";
          errors.cardCityError = false;
        }

        break;

      case "stateCard":
        if (Validator.isEmpty(data.stateCard)) {
          errors.stateCard = "State is required";
          errors.stateCardError = true;
        } else {
          errors.stateCard = "";
          errors.stateCardError = false;
        }
        break;

      case "cardZipCode":
        if (Validator.isEmpty(data.cardZipCode)) {
          errors.cardZipCode = "Zip code is required";
          errors.cardZipCodeError = true;
        } else if (
          data.cardZipCode.replace(/_/g, "").replace(/ /g, "").length < 5
        ) {
          errors.cardZipCode = "Zip code should consist of 5 characters";
          errors.cardZipCodeError = true;
        } else {
          errors.cardZipCode = "";
          errors.cardZipCodeError = false;
        }

        break;
      case "cardCvv":
        if (Validator.isEmpty(data.cardCvv)) {
          errors.cardCvv = "CVV is required";
          errors.cardCvvError = true;
        } else if (
          data.cardCvv.replace(/_/g, "").length < 3 ||
          data.cardCvv.replace(/_/g, "").length > 4
        ) {
          errors.cardCvv = "CVV should consist of min 3 and max 4 characters";
          errors.cardCvvError = true;
        } else {
          errors.cardCvv = "";
          errors.cardCvvError = false;
        }
        break;
      case "cardYear":
        if (Validator.isEmpty(data.cardYear)) {
          errors.cardYear = "Expiry Year is required";
          errors.cardYearError = true;
        } else if (data.cardYear.replace(/_/g, "").length !== 2) {
          errors.cardYear = "Expiration Year should be equal to two numbers";
          errors.cardYearError = true;
          // scrollViews.push(this.expirationYearRef);
        } else if (
          data.cardYear.replace(/_/g, "") <
          d
            .getFullYear()
            .toString()
            .substr(-2) *
            1
        ) {
          errors.cardYear = "Expiration Date must be not be in the past";
          errors.cardYearError = true;
        } else {
          if (
            data.cardYear.replace(/_/g, "").toString() ===
            (
              d
                .getFullYear()
                .toString()
                .substr(-2) * 1
            ).toString()
          ) {
            if (
              parseInt(data.cardMonth.replace(/_/g, ""), 10) <= d.getMonth()
            ) {
              errors.cardMonth =
                "Expiration Month should be equal to or greater than the current month";
              errors.cardMonthError = true;
            }
          } else {
            errors.cardMonth = "";
            errors.cardMonthError = false;
          }
          errors.cardYear = "";
          errors.cardYearError = false;
        }
        if (
          data.cardYear.replace(/_/g, "").toString() ===
          (
            d
              .getFullYear()
              .toString()
              .substr(-2) * 1
          ).toString()
        ) {
          if (parseInt(data.cardMonth.replace(/_/g, ""), 10) <= d.getMonth()) {
            errors.cardMonth =
              "Expiration Month should be equal to or greater than the current month";
            errors.cardMonthError = true;
          } else {
            errors.cardMonth = "";
            errors.cardMonthError = false;
          }
        }
        break;
      case "cardMonth":
        if (data.cardMonth.replace(/_/g, "").length === 0) {
          errors.cardMonth = "Month is required";
          errors.cardMonthError = true;
        } else if (
          Number.parseInt(data.cardMonth.replace(/_/g, ""), 10) <= 0 ||
          Number.parseInt(data.cardMonth.replace(/_/g, ""), 10) > 12
        ) {
          errors.cardMonth = "Month should be between 1 to 12";
          errors.cardMonthError = true;
        } else if (
          Number.parseInt(data.cardMonth.replace(/_/g, ""), 10) ===
          Number.parseInt(
            (
              d
                .getFullYear()
                .toString()
                .substr(-2) * 1
            ).toString(),
            10
          )
        ) {
          if (parseInt(data.cardMonth.replace(/_/g, ""), 10) <= d.getMonth()) {
            errors.cardMonth =
              "Expiration Month should be equal to or greater than the current month";
            errors.cardMonthError = true;
          } else {
            errors.cardMonth = "";
            errors.cardMonthError = false;
          }
        } else {
          errors.cardMonth = "";
          errors.cardMonthError = false;
        }
        break;
      case "":
        break;
      case "cardAddress2":
        break;
      case "recaptchaToken":
        if (data.recaptchaToken !== null) {
          if (Validator.isEmpty(data.recaptchaToken)) {
            errors.recaptchaTokenError = true;
          } else {
            errors.recaptchaTokenError = false;
          }
        }
        break;
      default:
        if (Validator.isEmpty(data.cardNumber)) {
          errors.cardNumber = "Card Number is required";
          errors.cardNumberError = true;
        } else if (
          data.cardNumber.replace(/_/g, "").replace(/ /g, "").length < 15
        ) {
          errors.cardNumber =
            "Card Number should consist of min 15 and max 16 characters";
          errors.cardNumberError = true;
        } else {
          errors.cardNumber = "";
          errors.cardNumberError = false;
        }

        if (Validator.isEmpty(data.cardFirstName)) {
          errors.cardFirstName = "First Name is required";
          errors.cardFirstNameError = true;
        } else if (
          data.cardFirstName.length < 2 ||
          data.cardFirstName.length > 20
        ) {
          errors.cardFirstName =
            "First name should consist of min 2 and max 20 characters";
          errors.cardFirstNameError = true;
        } else {
          errors.cardFirstName = "";
          errors.cardFirstNameError = false;
        }

        if (Validator.isEmpty(data.cardLastName)) {
          errors.cardLastName = "Last Name is required";
          errors.cardLastNameError = true;
        } else if (
          data.cardLastName.length < 2 ||
          data.cardLastName.length > 20
        ) {
          errors.cardLastName =
            "Last name should consist of min 2 and max 20 characters";
          errors.cardLastNameError = true;
        } else {
          errors.cardLastName = "";
          errors.cardLastNameError = false;
        }

        if (Validator.isEmpty(data.cardAddress)) {
          errors.cardAddress = "Address is required";
          errors.cardAddressError = true;
        } else if (
          data.cardAddress.length < 2 ||
          data.cardAddress.length > 50
        ) {
          errors.cardAddress =
            "Street address should consist of min 2 and max 50 characters";
          errors.cardAddressError = true;
        } else {
          errors.cardAddress = "";
          errors.cardAddressError = false;
        }

        if (Validator.isEmpty(data.cardCity)) {
          errors.cardCity = "City is required";
          errors.cardCityError = true;
        } else if (data.cardCity.length < 2 || data.cardCity.length > 30) {
          errors.cardCity =
            "City should consist of min 2 and max 30 characters";
          errors.cardCityError = true;
        } else {
          errors.cardCity = "";
          errors.cardCityError = false;
        }

        if (Validator.isEmpty(data.stateCard)) {
          errors.stateCard = "State is required";
          errors.stateCardError = true;
        } else {
          errors.stateCard = "";
          errors.stateCardError = false;
        }

        if (data.recaptchaToken !== null) {
          if (Validator.isEmpty(data.recaptchaToken)) {
            errors.recaptchaTokenError = true;
          } else {
            errors.recaptchaTokenError = false;
          }
        }

        if (Validator.isEmpty(data.cardZipCode)) {
          errors.cardZipCode = "Zip code is required";
          errors.cardZipCodeError = true;
        } else if (
          data.cardZipCode.replace(/_/g, "").replace(/ /g, "").length < 5
        ) {
          errors.cardZipCode = "Zip code should consist of 5 characters";
          errors.cardZipCodeError = true;
        } else {
          errors.cardZipCode = "";
          errors.cardZipCodeError = false;
        }

        if (data.cardMonth.replace(/_/g, "").length === 0) {
          errors.cardMonth = "Month is required";
          errors.cardMonthError = true;
        } else if (
          parseInt(data.cardMonth.replace(/_/g, ""), 10) > 12 ||
          parseInt(data.cardMonth.replace(/_/g, ""), 10) === 0
        ) {
          errors.cardMonth = "Expiry Month should be equal to two numbers";
          errors.cardMonthError = true;
        }

        if (Validator.isEmpty(data.cardCvv)) {
          errors.cardCvv = "CVV is required";
          errors.cardCvvError = true;
        } else if (
          data.cardCvv.replace(/_/g, "").length < 3 ||
          data.cardCvv.replace(/_/g, "").length > 4
        ) {
          errors.cardCvv = "CVV should consist of min 3 and max 4 characters";
          errors.cardCvvError = true;
        } else {
          errors.cardCvv = "";
          errors.cardCvvError = false;
        }

        if (Validator.isEmpty(data.cardYear)) {
          errors.cardYear = "Expiry Year is required";
          errors.cardYearError = true;
        } else if (data.cardYear.replace(/_/g, "").length !== 2) {
          errors.cardYear = "Expiration Year should be equal to two numbers";
          errors.cardYearError = true;
          // scrollViews.push(this.expirationYearRef);
        } else if (
          data.cardYear.replace(/_/g, "") <
          d
            .getFullYear()
            .toString()
            .substr(-2) *
            1
        ) {
          errors.cardYear = "Expiration Date must be not be in the past";
          errors.cardYearError = true;
        } else {
          errors.cardYear = "";
          errors.cardYearError = false;
        }

        if (
          data.cardYear.replace(/_/g, "").toString() ===
          (
            d
              .getFullYear()
              .toString()
              .substr(-2) * 1
          ).toString()
        ) {
          if (
            parseInt(data.cardMonth.replace(/_/g, ""), 10) <
            parseInt(d.getMonth().toString(), 10)
          ) {
            errors.cardMonth =
              "Expiration Month should be equal to or greater than the current month";
            errors.cardMonthError = true;
          } else {
            errors.cardMonth = "";
            errors.cardMonthError = false;
          }
        }
        break;
    }

    // console.log('ssssssss',errors)

    return {
      errorsState: errors,
      errors:
        errors.cardNumberError === false &&
        errors.cardFirstNameError === false &&
        errors.cardLastNameError === false &&
        errors.cardMonthError === false &&
        errors.cardYearError === false &&
        errors.cardCvvError === false &&
        errors.cardAddressError === false &&
        errors.cardCityError === false &&
        errors.stateCardError === false &&
        errors.cardZipCodeError === false &&
        errors.recaptchaTokenError === false
          ? {}
          : errors,
      isValid: !(
        errors.cardNumberError === false &&
        errors.cardFirstNameError === false &&
        errors.cardLastNameError === false &&
        errors.cardMonthError === false &&
        errors.cardYearError === false &&
        errors.cardCvvError === false &&
        errors.cardAddressError === false &&
        errors.cardCityError === false &&
        errors.stateCardError === false &&
        errors.cardZipCodeError === false &&
        errors.recaptchaTokenError === false
      ),
    };
  }

  /**
   * Upload Signature
   */
  uploadSignature() {
    this.setState({ updateImage: true });
  }

  accountNameChange = (e) => {
    if(this.state.radioAddedAccountChecked===false){
    this.setState({
      radioAddedAccountChecked: true,
      radioAccountValue: e.target.value,
    });
  }
    if(this.state.radioAddedAccountChecked){
    this.setState({radioAddedAccountChecked:false,
    radioAccountValue:""})
  }
  // this.setState({
  //       radioAddedAccountChecked: true,
  //       radioAccountValue: e.target.value,
  //     });
  };

  // clickedToToggle = () => {
  //   if
  // }

  cardNameChange = (e) => {
    // this.setState({
    //   radioAddedCardChecked: true,
    //   radioCardValue: e.target.value,
    // });
    if(this.state.radioAddedCardChecked===false){
      this.setState({
        radioAddedCardChecked: true,
        radioCardValue: e.target.value,
      });
    }
      if(this.state.radioAddedCardChecked){
        this.setState({radioAddedCardChecked: false,
        radioCardValue: ""})
    }
  };

  validateAddress = () => {
    let zipPopupError = "";
    let address1PopupError = "";
    let cityPopupError = "";

    if (this.state.zipPopup && this.state.zipPopup.length < 5) {
      zipPopupError = "Please fill 5 digit zip code";
    }

    if (
      this.state.address1Popup &&
      (this.state.address1Popup.length < 2 ||
        this.state.address1Popup.length > 50)
    ) {
      address1PopupError = "Please fill 2 to 50 characters";
    }

    if (
      this.state.cityPopup &&
      (this.state.cityPopup.length < 2 || this.state.cityPopup.length > 30)
    ) {
      cityPopupError = "Please fill 2 to 30 characters in city";
    }

    if (zipPopupError || address1PopupError || cityPopupError) {
      this.setState({
        zipPopupError,
        address1PopupError,
        cityPopupError,
        nextButtonStepActive: false,
      });
      return false;
    }
    this.setState({
      nextButtonStepActive: true,
      linkAccountStep1: false,
      linkCardAccountStep1: false,
    });
    return true;
  };

  validateCardAddress = () => {
    let zipCardPopupError = "";
    let address1CardPopupError = "";
    let cityCardPopupError = "";

    if (this.state.zipCardPopup && this.state.zipCardPopup.length < 5) {
      zipCardPopupError = "Please fill 5 digit zip code";
    }

    if (
      this.state.address1CardPopup &&
      (this.state.address1CardPopup.length < 2 ||
        this.state.address1CardPopup.length > 50)
    ) {
      address1CardPopupError = "Please fill 2 to 50 characters";
    }

    if (
      this.state.cityCardPopup &&
      (this.state.cityCardPopup.length < 2 ||
        this.state.cityCardPopup.length > 30)
    ) {
      cityCardPopupError = "Please fill 2 to 30 characters in city";
    }

    if (zipCardPopupError || address1CardPopupError || cityCardPopupError) {
      this.setState({
        zipCardPopupError,
        address1CardPopupError,
        cityCardPopupError,
        nextCardButtonStepActive: false,
      });
      return false;
    }
    this.setState({
      nextCardButtonStepActive: true,
      linkAccountStep1: false,
      linkCardAccountStep1: false,
    });
    return true;
  };

  onChangeAddress = (e) => {
    this.setState(
      {
        [e.target.name]: e.target.value,
      },
      () => {
        let {
          address1Popup,
          address2Popup,
          cityPopup,
          zipPopup,
          statePopup,
          statePopupName,
        } = this.state;

        if (address1Popup == "") {
          this.setState({
            address1PopupError: true,
          });
        }
        if (statePopup == "" || statePopupName == "State") {
          this.setState({
            statePopupError: true,
            addressNextButton: false,
          });
        }
        if (address2Popup == "") {
          this.setState({
            address2PopupError: true,
          });
        }
        if (cityPopup == "") {
          this.setState({
            cityPopupError: true,
          });
        }
        if (zipPopup == "") {
          this.setState({
            zipPopupError: true,
          });
        }
        if (
          address1Popup != "" &&
          statePopup != "" &&
          cityPopup != "" &&
          zipPopup != "" &&
          statePopupName != "State"
        ) {
          this.setState({
            addressNextButton: true,
            addressNextButton: true,
          });
        } else {
          this.setState({
            addressNextButton: false,
            addressNextButton: false,
          });
        }
      }
    );
  };

  onChangeCardAddress = (e) => {
    this.setState(
      {
        [e.target.name]: e.target.value,
      },
      () => {
        let {
          address1CardPopup,
          address2CardPopup,
          cityCardPopup,
          zipCardPopup,
          stateCardPopup,
          stateCardPopupName,
        } = this.state;
        if (address1CardPopup == "") {
          this.setState({
            address1CardPopupError: true,
          });
        }
        if (stateCardPopup == "" || stateCardPopupName == "State") {
          this.setState({
            stateCardPopupError: true,
            addressCardNextButton: false,
          });
        }
        if (address2CardPopup == "") {
          this.setState({
            address2CardPopupError: true,
          });
        }
        if (cityCardPopup == "") {
          this.setState({
            cityCardPopupError: true,
          });
        }
        if (zipCardPopup == "") {
          this.setState({
            zipCardPopupError: true,
          });
        }
        if (
          address1CardPopup != "" &&
          cityCardPopup != "" &&
          zipCardPopup != "" &&
          stateCardPopupName != "State" &&
          stateCardPopup != ""
        ) {
          this.setState({
            addressCardNextButton: true,
          });
        } else {
          this.setState({
            addressCardNextButton: false,
          });
        }
      }
    );
  };

  onChangeAddressSelect = (statePopup, statePopupName) => {
    this.setState(
      {
        statePopup,
        statePopupName,
      },
      () => {
        let {
          address1Popup,
          address2Popup,
          cityPopup,
          zipPopup,
          statePopup,
          statePopupName,
        } = this.state;

        if (address1Popup == "") {
          this.setState({
            address1PopupError: true,
          });
        }
        if (statePopup == "" || statePopupName == "State") {
          this.setState({
            statePopupError: true,
            addressNextButton: false,
          });
        }
        if (address2Popup == "") {
          this.setState({
            address2PopupError: true,
          });
        }
        if (cityPopup == "") {
          this.setState({
            cityPopupError: true,
          });
        }
        if (zipPopup == "") {
          this.setState({
            zipPopupError: true,
          });
        }
        if (
          address1Popup != "" &&
          statePopup != "" &&
          cityPopup != "" &&
          zipPopup != "" &&
          statePopupName != "State"
        ) {
          this.setState({
            createAccEnable: true,
            addressNextButton: true,
          });
        } else {
          this.setState({
            createAccEnable: false,
            addressNextButton: false,
          });
        }
      }
    );
  };

  onChangeCardAddressSelect = (stateCardPopup, stateCardPopupName) => {
    console.log("stateCardPopupName", stateCardPopupName);
    this.setState(
      {
        stateCardPopup,
        stateCardPopupName,
      },
      () => {
        let {
          address1CardPopup,
          address2CardPopup,
          cityCardPopup,
          zipCardPopup,
          stateCardPopup,
          stateCardPopupName,
        } = this.state;

        if (address1CardPopup == "") {
          this.setState({
            address1CardPopupError: true,
          });
        }
        if (stateCardPopup == "" || stateCardPopupName == "State") {
          this.setState({
            stateCardPopupError: true,
            addressCardNextButton: false,
          });
        }
        if (address2CardPopup == "") {
          this.setState({
            address2CardPopupError: true,
          });
        }
        if (cityCardPopup == "") {
          this.setState({
            cityCardPopupError: true,
          });
        }
        if (zipCardPopup == "") {
          this.setState({
            zipCardPopupError: true,
          });
        }
        if (
          address1CardPopup != "" &&
          cityCardPopup != "" &&
          zipCardPopup != "" &&
          stateCardPopupName != "State" &&
          stateCardPopup != ""
        ) {
          this.setState({
            createAccEnable: true,
            addressCardNextButton: true,
          });
        } else {
          this.setState({
            createAccEnable: false,
            addressCardNextButton: false,
          });
        }
      }
    );
  };

  handleSubmitNextAddress = (e) => {
    e.preventDefault();
    let isValid = this.validateAddress();
    if (isValid) {
      this.setState({
        value: "3",
        address1PopupError: "",
        cityPopupError: "",
        statePopupError: "",
        zipPopupError: "",
      });
    }
  };

  handleSubmitNextCardAddress = (e) => {
    e.preventDefault();
    let isValid = this.validateCardAddress();
    if (isValid) {
      this.setState({
        cardValue: "3",
        address1CardPopupError: "",
        cityCardPopupError: "",
        stateCardPopupError: "",
        zipCardPopupError: "",
        // addCardAccountStep1: true
      });
    }
  };

  /**
   * Edit Residences
   * @param {id} id
   * @param {number} stateid
   * @param {number} beginYear
   * @param {number} endYear
   */

  editResidences(id, stateid, beginYear, endYear, primaryFlag) {
    this.setState({
      rSinceFrom: beginYear,
      rSinceTo: endYear,
      rState: stateid,
      userResidenceId: id,
      primaryFlag: primaryFlag,
      modalIsOpenResidences: true,
      saveAddress: false,
      showSaveButtonR: false,
      showUpadeButtonR: true,
      errorsResidence: {},
    });
  }

  /**
   * Delete Residence
   */
  deleteResidences(e) {
    const { userId } = this.state;
    this.props.deleteResidencesData({ addressID: e, userId });
  }

  _cSince1(e) {
    const { rSinceTo } = this.state;
    this.setState({
      rSinceFrom: e.value,
      rSinceTo:
        e.value !== "Prior to 1990"
          ? rSinceTo === "Prior to 1990"
            ? ""
            : e.value <= rSinceTo
            ? rSinceTo
            : ""
          : rSinceTo,
      errorsResidence: {},
    });
  }

  _cSince2(e) {
    const { rSinceFrom } = this.state;
    this.setState((prevState) => ({
      rSinceTo:
        rSinceFrom !== "Prior to 1990"
          ? e.value === "Prior to 1990"
            ? ""
            : rSinceFrom <= e.value
            ? e.value
            : ""
          : e.value,
      errorsResidence: {
        ...prevState.errorsResidence, // keep all other key-value pairs
        rSinceToError:
          rSinceFrom !== "Prior to 1990"
            ? e.value === "Prior to 1990"
              ? true
              : rSinceFrom <= e.value
              ? ""
              : true
            : "",
        rSinceTo:
          rSinceFrom !== "Prior to 1990"
            ? e.value === "Prior to 1990"
              ? "Since to year should be greater than since from"
              : rSinceFrom <= e.value
              ? ""
              : "Since to year should be greater than since from"
            : "",
      },
    }));
    // errorsResidence.rSinceFromError
  }

  validate = () => {
    // let accountHolderNameError= "";
    let accountNumberError = "";
    let routingNumberError = "";
    let accountTypeError = "";
    // let displayNameError= "";

    if (this.state.routingNumber.length != 9 && this.state.routingNumber > 0) {
      routingNumberError = "Please fill 9 digit routing number";
    } else if (this.state.routingNumber < 0) {
      routingNumberError = "Routing number can't be negative";
    }

    if (!this.state.accountType) {
      accountTypeError = "Please select account type";
    }

    if (this.state.accountNumber.length != 12 && this.state.accountNumber > 0) {
      accountNumberError = "Please fill 12 digit account number";
    } else if (this.state.accountNumber < 0) {
      accountNumberError = "Account number can't be negative";
    }

    if (accountNumberError || routingNumberError || accountTypeError) {
      this.setState({
        routingNumberError,
        accountNumberError,
        accountTypeError,
      });
      return false;
    }
    return true;
  };

  handlePopupSubmit = (e) => {
    e.preventDefault();
    const isValid = this.validate();
    if (isValid && this.state.addNewAccWithoutAdd == "") {
      this.createAccount();
    }
    if (
      isValid &&
      this.state.addNewAccWithoutAdd == "addNewAccount" &&
      this.state.addMultipleAccountState == true
    ) {
      this.AddMultipleAccount();
    }
    // if (isValid && this.state.addMultipleAccountState == true) {
    //   this.AddMultipleAccount();
    // }
  };

  handleCardPopupSubmit = (e) => {
    e.preventDefault();
    if (this.state.addNewCardWithoutAdd == "") {
      this.createAccountCard();
    }
    // if (this.state.addNewCardWithoutAdd == "addNewCard") {
    //   this.AddMultipleAccount();
    // }
    // if (this.state.addMultipleAccountState == true) {
    //   this.AddMultipleAccount();
    // }
  };

  handleCardPopupAlreadyLinkedSubmit = (e) => {
    e.preventDefault();
    // if (this.state.addNewCardWithoutAdd == "") {
    //   this.createAccountCard();
    // }
    this.AddMultipleCard();
    // if (this.state.addNewCardWithoutAdd == "addNewCard") {
    //   this.AddMultipleAccount();
    // }
    // if (this.state.addMultipleAccountState == true) {
    //   this.AddMultipleAccount();
    // }
  };

  handleAlreadyAddedAccount = (e) => {
    e.preventDefault();
    const data = {
      bankAccountId: this.state.radioAccountValue,
      userId: localStorage.getItem("userId"),
    };

    this.props.setDefaultBankAccount({ data });
    this.setState({
      bankAccountConfirmationPopup: false,
      radioAddedAccountChecked: true,
    });
    // this.setDefaultBankAccount
  };

  handleAlreadyAddedCard = (e) => {
    e.preventDefault();
    const data = {
      cardId: this.state.radioCardValue,
      userId: localStorage.getItem("userId"),
    };

    this.props.setDefaultCard({ data });
    this.setState({
      bankCardConfirmationPopup: false,
      radioAddedCardChecked: true,
    });
    // this.setDefaultBankAccount
  };

  handleAddNewAccount = (e) => {
    e.preventDefault();
    this.setState({
      bankAccountConfirmationPopup: false,
    });
    this.linkAccountPopup(e.target.value);
  };

  handleAddNewCard = (e) => {
    e.preventDefault();
    this.setState({
      bankCardConfirmationPopup: false,
      cardNickName: "",
    });
    this.linkCardPopup(e.target.value);
  };

  /**
   * Change input value on change
   */
  onChangeStep2 = (e) => {
    this.setState(
      {
        [e.target.name]: e.target.value,
      },
      () => {
        let {
          accountHolderName,
          accountNumber,
          routingNumber,
          displayName,
          accountType,
        } = this.state;
        if (accountHolderName == "") {
          this.setState({
            accountHolderNameError: true,
          });
        }
        if (accountType == "") {
          this.setState({
            accountTypeError: true,
          });
        }
        if (accountNumber == "") {
          this.setState({
            accountNumberError: true,
          });
        }
        if (routingNumber == "") {
          this.setState({
            routingNumberError: true,
          });
        }
        if (displayName == "") {
          this.setState({
            displayNameError: true,
          });
        }
        if (
          accountHolderName != "" &&
          accountNumber != "" &&
          routingNumber != "" &&
          displayName != "" &&
          accountType != ""
        ) {
          this.setState({
            createAccEnable: true,
          });
        } else {
          this.setState({
            createAccEnable: false,
          });
        }
      }
    );
  };

  onChangeStep2Select = (accountType) => {
    this.setState(
      {
        accountType,
      },
      () => {
        let {
          accountHolderName,
          accountNumber,
          routingNumber,
          displayName,
          accountType,
        } = this.state;
        if (accountHolderName == "") {
          this.setState({
            accountHolderNameError: true,
          });
        }
        if (accountType == "") {
          this.setState({
            accountTypeError: true,
          });
        }
        if (accountNumber == "") {
          this.setState({
            accountNumberError: true,
          });
        }
        if (routingNumber == "") {
          this.setState({
            routingNumberError: true,
          });
        }
        if (displayName == "") {
          this.setState({
            displayNameError: true,
          });
        }
        if (
          accountHolderName != "" &&
          accountNumber != "" &&
          routingNumber != "" &&
          displayName != "" &&
          accountType != ""
        ) {
          this.setState({
            createAccEnable: true,
          });
        } else {
          this.setState({
            createAccEnable: false,
          });
        }
      }
    );
  };

  onChange(e) {
    this.setState(
      {
        [e.target.name]: e.target.value,
        errors: {},
        errorsResidence: {},
        errorsCompany: {},
      },
      () => {
        if (this.state.cEmail !== "") {
          this.props.checkEmailVerify({ email: this.state.cEmail });
        }
      }
    );
  }

  onChangeEditAccount = (e) => {
    if (e.target.value.length <= 0) {
      this.setState({
        [e.target.name]: e.target.value,
        errorbankName: true,
        updateBankButton: false,
      });
    } else {
      this.setState({
        ...this.state.bankName,
        bankName: e.target.value,
        errorbankName: false,
        updateBankButton: true,
      });
    }
  };

  onChangeEditCard = (e) => {
    if (e.target.value.length <= 0) {
      this.setState({
        [e.target.name]: e.target.value,
        errorCardName: true,
        updateCardButton: false,
      });
    } else {
      this.setState({
        ...this.state.cardNickName,
        cardNickName: e.target.value,
        errorCardName: false,
        updateCardButton: true,
      });
    }
  };

  changeBankNickName = () => {
    this.setState({
      isLoading: true,
      errorbankName: false,
    });
    const data = {
      userId: localStorage.getItem("userId"),
      bankAccountId: this.state.bankId,
      accountDisplayName: this.state.bankName,
    };
    this.props.updateBankAccountDetails({ data });
  };

  changeCardNickName = () => {
    this.setState({
      isLoading: true,
      errorCardName: false,
    });
    const data = {
      userId: localStorage.getItem("userId"),
      cardId: this.state.cardId,
      cardNickName: this.state.cardNickName,
    };
    this.props.updateCardDetails({ data });
  };

  cancelEditModel = () => {
    this.setState({
      openEditModel: false,
      openEditCardModel: false,
    });
    this.props.getAddedBankAccountsForUser(localStorage.getItem("userId"));
    this.props.getAddedBankAccountsForUser(localStorage.getItem("userId"));
  };

  _cSelect(e) {
    this.setState({ cState: e.value });
  }

  _rSelect(e) {
    this.setState({ rState: e.target.value, errorsResidence: {} });
  }

  /**
   * Get States and Country Data
   */
  componentDidMount() {
    this.props.getAllStates();
    this.props.getAllCountry();
    this.props.getTranscardPaymentMethods();
    this.props.getUserTransactionsHistory(localStorage.getItem("userId"));
    this.props.getAddedBankAccountsForUser(localStorage.getItem("userId"));
    this.props.getAddedCardsForUser(localStorage.getItem("userId"));
    this.props.getAllBankAccountsForUser(localStorage.getItem("userId"));
    this.props.getAllAddedCardsForUser(localStorage.getItem("userId"));
    this.props.getCollectedSettlementsHistoryForUser(
      localStorage.getItem("userId")
    );
    this.props.getUserTransactionsHistory(localStorage.getItem("userId"));
  }

  /**
   * Get Logged User Info
   */
  componentWillMount() {
    this.props.getConsumerUser(localStorage.getItem("userId"));
    const intervalId = setInterval(
      this.scrollStep.bind(this),
      this.props.delayInMs
    );
    this.props.getConsumerUserResidenceAction({
      userId: localStorage.getItem("userId"),
    });

    // Auth.currentUserInfo()
    //   .then((res) => {
    //     const Fname = res.attributes['custom:first_name'];
    //     const Lname = res.attributes['custom:last_name'];
    //     const name = `${Fname} ${Lname}`;
    //     this.setState({
    //       cEmail: res.attributes.email,
    //       cEmployer: res.attributes['custom:employer'],
    //       roleName: res.attributes['custom:roleName'],
    //       readDisclaimer: res.attributes['custom:readDisclaimer'],
    //       readPrivacyPolicy: res.attributes['custom:readPrivacyPolicy'],
    //       readLetterOfAgency: res.attributes['custom:readLetterOfAgency'],
    //       readUserAgreement: res.attributes['custom:readUserAgreement'],
    //       UserName: name,
    //     });
    //   })
    //   .catch(error => error);
    this.setState({
      intervalId,
    });
  }

  editAccount = () => {
    this.props.getAddedBankAccountsForUser(localStorage.getItem("userId"));
    this.setState({
      openEditModel: true,
    });
  };

  editCard = () => {
    this.props.getAddedCardsForUser(localStorage.getItem("userId"));
    this.setState({
      openEditCardModel: true,
    });
  };

  handleSubmitNext = () => {
    this.setState({
      value: "2",
    });
  };

  handleCancel = () => {
    this.setState({
      linkAccountStep1: false,
      linkCardAccountStep1: false,
      addAccountStep1: false,
      addCardAccountStep1: false,
      bankAccountConfirmationPopup: false,
      addMultipleAccountState: false,
      checkboxState: false,
      viewAccountState: false,
      errorCheckbox: true,
      accountHolderName: "",
      accountNumber: "",
      routingNumber: "",
      accountType: "",
      displayName: "",
      value: "1",
      routingNumberError: "",
      accountNumberError: "",
      address1Popup: "",
      address2Popup: "",
      cityPopup: "",
      statePopup: "",
      statePopupError: "",
      stateCardPopupError: "",
      stateCardPopup: "",
      zipPopup: "",
      address1PopupError: "",
      address2PopupError: "",
      cityPopupError: "",
      zipPopupError: "",
      zipCodeError: "",
      stateError: "",
      statePopupName: "",
      stateCardPopupName: "",
      cardValue: "1",
      address1CardPopup: "",
      address2CardPopup: "",
      cityCardPopup: "",
      zipCardPopup: "",
      address1CardPopupError: "",
      address2CardPopupError: "",
      cityCardPopupError: "",
      zipCardPopupError: "",
      zipCardCodeError: "",
      achState: false,
      instantTransferState: false,
      addressNextButton: false,
      addressCardNextButton: false,
      nextButtonStepActive: false,
      nextCardButtonStepActive: false,
      cardFirstName: "",
      cardFirstNameError: false,
      cardLastName: "",
      cardLastNameError: false,
      cardNickName: "",
      cardNickNameError: false,
      cardNumber: "",
      cardNumberError: false,
      cardMonth: "",
      cardMonthError: false,
      cardYear: "",
      cardYearError: false,
      cardCvv: "",
      cardCvvError: false,
    });
  };

  AddMultipleAccount = async () => {
    this.setState({
      isLoading: true,
    });
    const data = {
      userId: localStorage.getItem("userId"),
      accountHolderName: this.state.accountHolderName,
      accountNumber: this.state.accountNumber,
      routingNumber: this.state.routingNumber,
      accountType: this.state.accountType,
      displayName: this.state.displayName,
    };
    await this.props.addUserBankAccount({ data });
  };

  AddMultipleCard = async () => {
    this.setState({
      isLoading: true,
      addUserCardState: true,
    });
    let cardExpirationDate = `20${this.state.cardYear}-${this.state.cardMonth}`;
    const data = {
      userId: localStorage.getItem("userId"),
      cvc: this.state.cardCvv,
      firstName: this.state.cardFirstName,
      lastName: this.state.cardLastName,
      cardNumber: this.state.cardNumber.replace(/_/g, "").replace(/ /g, ""),
      cardNickName: this.state.cardNickName,
      cardExpirationDate: cardExpirationDate,
      streeAddress: this.state.address1CardPopup,
      streetAddress2: this.state.address2CardPopup,
      city: this.state.cityCardPopup,
      zipCode: this.state.zipCardPopup,
    };
    await this.props.addUserCard({ data });
  };

  handleSubmitBack = () => {
    this.setState({
      value: "1",
    });
  };

  createAccount = () => {
    const data = {
      userId: localStorage.getItem("userId"),
      accountHolderName: this.state.accountHolderName,
      accountNumber: this.state.accountNumber,
      routingNumber: this.state.routingNumber,
      accountType: this.state.accountType,
      displayName: this.state.displayName,
      streeAddress: this.state.address1Popup,
      streetAddress2: this.state.address2Popup,
      city: this.state.cityPopup,
      stateId: this.state.statePopup,
      zipCode: this.state.zipPopup,
    };

    this.setState({
      isLoading: true,
    });

    this.props.createTranscardAccount({ data });
  };

  createAccountCard = () => {
    let cardExpirationDate = `20${this.state.cardYear}-${this.state.cardMonth}`;
    const data = {
      userId: localStorage.getItem("userId"),
      cvc: this.state.cardCvv,
      firstName: this.state.cardFirstName,
      lastName: this.state.cardLastName,
      cardNumber: this.state.cardNumber.replace(/_/g, "").replace(/ /g, ""),
      cardNickName: this.state.cardNickName,
      cardExpirationDate: cardExpirationDate,
      streeAddress: this.state.address1CardPopup,
      streetAddress2: this.state.address2CardPopup,
      city: this.state.cityCardPopup,
      zipCode: this.state.zipCardPopup,
      stateId: this.state.stateCardPopup,
    };
    this.setState({
      isLoading: true,
      transcardCardState: true,
    });

    this.props.createTranscardCard({ data });
  };

  scrollStep = () => {
    if (window.pageYOffset === 0) {
      clearInterval(this.state.intervalId);
    }
    window.scroll(0, window.pageYOffset - this.props.scrollStepInPx);
  };

  finalSubmit = (data) => {
    const { cFirstName, cLastName, cEmail } = this.state;
    this.props.uploadfile({
      image: data.file,
      firstName: cFirstName,
      lastName: cLastName,
      email: cEmail,
      streeAddress: "",
    });
    this.setState({
      file: data.file,
      updateImage: false,
      modalIsOpen: false,
      // signatureDefaultValue: data.signatureVlaue,
    });
  };

  componentDidUpdate() {
    const {
      ConsumerUserData,
      saveResidence,
      ConsumerUpdateProfileData,
      consumerResidence,
      updateResidence,
      deleteResidenceData,
    } = this.props.data;
    const {
      stateSuccess,
      saveResidence1,
      ConsumerUpdateProfileData1,
      consumerResidences,
      updateResidence1,
      deleteResidenceData1,
    } = this.state;
    if (stateSuccess !== ConsumerUserData) {
      this.setState({
        userId: ConsumerUserData.userId,
        cognitoClientId: ConsumerUserData.cognitoClientId,
        cPhone: ConsumerUserData.mobilePhone,
        cCountryCode: ConsumerUserData.countryCode,
        cFirstName: ConsumerUserData.firstName,
        cLastName: ConsumerUserData.lastName,
        cEmployer: ConsumerUserData.employer,
        cEmail: ConsumerUserData.email,
        oldEmail: ConsumerUserData.email,
        readDisclaimer: ConsumerUserData.readDisclaimer,
        readLetterOfAgency: ConsumerUserData.readLetterOfAgency,
        readPrivacyPolicy: ConsumerUserData.readPrivacyPolicy,
        readUserAgreement: ConsumerUserData.readUserAgreement,
        cNotification: ConsumerUserData.notifyByText,
        cUpdateClaim: ConsumerUserData.notifyProductUpdates,
        file: ConsumerUserData.signatureImageFilePath,
        privacyPolicyPath: ConsumerUserData.privacyPolicyPath,
        agreementLetterPath: ConsumerUserData.agreementLetterPath,
        letterOfAgencyPath: ConsumerUserData.letterOfAgencyPath,
        walletBalance: ConsumerUserData.walletBalance
          ? ConsumerUserData.walletBalance
          : 0,
        stateSuccess: ConsumerUserData,
        isLoading: false,
        signatureDefaultValue: `${ConsumerUserData.firstName} ${ConsumerUserData.lastName}`,
      });
    }

    if (ConsumerUpdateProfileData1 !== ConsumerUpdateProfileData) {
      if (ConsumerUpdateProfileData.statusText !== undefined) {
        if (this.state.ConsumerUpdateProfileDataStatus === true) {
          this.setState({
            ConsumerUpdateProfileData1: ConsumerUpdateProfileData,
            ConsumerUpdateProfileDataStatus: false,
            isLoading: false,
          });
          // toast.info('Profile update successfully!', {
          //   position: toast.POSITION.TOP_CENTER,
          // });
          // }
        }
      }
    }

    if (consumerResidence !== undefined) {
      if (consumerResidences !== consumerResidence) {
        this.setState({
          consumerResidences: consumerResidence,
          isLoading: false,
        });
        this.closeModalResidences();
      }
    }
    if (
      updateResidence &&
      updateResidence.userResidenceId &&
      updateResidence !== undefined
    ) {
      if (updateResidence1 !== updateResidence) {
        this.setState({
          updateResidence1: updateResidence,
        });
        this.props.getConsumerUserResidenceAction({
          userId: localStorage.getItem("userId"),
        });
        this.closeModalResidences();
      }
    }
    if (
      deleteResidenceData &&
      deleteResidenceData.code == 200 &&
      deleteResidenceData !== undefined
    ) {
      if (deleteResidenceData1 !== deleteResidenceData) {
        this.setState({
          deleteResidenceData1: deleteResidenceData,
        });
        this.props.getConsumerUserResidenceAction({
          userId: localStorage.getItem("userId"),
        });
      }
    }
    if (
      saveResidence &&
      saveResidence.userResidenceId &&
      saveResidence !== undefined
    ) {
      if (saveResidence1 !== saveResidence) {
        this.setState({
          saveResidence1: saveResidence,
        });
        this.props.getConsumerUserResidenceAction({
          userId: localStorage.getItem("userId"),
        });
        this.closeModalResidences();
      }
    }
  }

  _cCountrySelect(e) {
    this.setState({ cCountryCode: e.value });
  }

  /**
   * Check if valid consumer
   */
  isValidConsumer() {
    const { errors, isValidConsumer } = this.validateInputConsumer(this.state);

    if (!isValidConsumer) {
      this.setState({ errors });
    }
    return isValidConsumer;
  }

  makeDefaultAccount = (e) => {
    if (e.target.name == "Make Default") {
      const data = {
        bankAccountId: e.target.value,
        userId: localStorage.getItem("userId"),
      };
      this.props.setDefaultBankAccount({ data });
    }
  };

  removeBankAccount = async (e) => {
    const data = {
      bankAccountId: e.target.value,
      userId: localStorage.getItem("userId"),
    };
    await this.props.deleteUserBankAccount({ data });
    setTimeout(() => {
      this.props.getAllBankAccountsForUser(localStorage.getItem("userId"));
    }, 1000);

    this.setState({
      openEditModel: false,
      transcardAccountState: false,
      showDeleteConfirmation: false,
    });
  };

  removeBankCard = async (e) => {
    const data = {
      bankAccountId: e.target.value,
      userId: localStorage.getItem("userId"),
    };
    await this.props.deleteUserCard({ data });
    setTimeout(() => {
      this.props.getAllAddedCardsForUser(localStorage.getItem("userId"));
    }, 1000);

    this.setState({
      openEditModel: false,
      openEditCardModel: false,
      transcardAccountState: false,
      transcardCardState: false,
      showDeleteConfirmation: false,
    });
  };

  isValidResidence() {
    const { errorsResidence, isValidResidence } = this.validateResidence(
      this.state
    );

    if (!isValidResidence) {
      this.setState({ errorsResidence });
    }
    return isValidResidence;
  }

  accountTypePopup = () => {
    this.setState({
      accountTypePopupState: true,
    });
  };

  openAccountTypePopup = () => {
    this.setState({
      accountTypePopupState: true,
    });
  };

  closeAccountTypePopup = () => {
    this.setState({
      accountTypePopupState: false,
      modalIsOpenResidences: false,
      linkAccountStep1: false,
      linkCardAccountStep1: false,
      viewAccountState: false,
      addAccountStep1: false,
      addCardAccountStep1: false,
      saveAddress: false,
      openEditModel: false,
      openEditCardModel: false,
      bankAccountConfirmationPopup: false,
      nextButtonStepActive: false,
      nextCardButtonStepActive: false,
      achState: false,
      instantTransferState: false,
      cardValue: "1",
      address1CardPopup: "",
      address2CardPopup: "",
      cityCardPopup: "",
      zipCardPopup: "",
      address1CardPopupError: "",
      address2CardPopupError: "",
      cityCardPopupError: "",
      zipCardPopupError: "",
      zipCardCodeError: "",
    });
  };

  handleSubmitTransferType = (e) => {
    e.preventDefault();
    if (this.state.achState) {
      this.setState({
        accountTypePopupState: false,
        linkCardAccountStep1: false,
      });
      if (this.state.userHasNoAccounts == true) {
        this.linkAccountPopup("addNewLinkAccount");
      }
      if (this.state.userHasNoAccounts == false) {
        this.addedBankReviewPopup();
      }
      // this.disburseAmountPopup();
      // this.addedBankReviewPopup();
    } else {
      this.setState({
        accountTypePopupState: false,
        // linkCardAccountStep1: true,
      });
      if (this.state.userHasNoCards == true) {
        this.linkCardPopup("addNewLinkCard");
      }
      if (this.state.userHasNoCards == false) {
        this.addedCardReviewPopup();
      }
    }
  };

  onTransferCheck = (e) => {
    if (e.target.value == "ach") {
      this.setState({
        achState: true,
        instantTransferState: false,
      });
    } else {
      this.setState({
        instantTransferState: true,
        achState: false,
      });
    }
  };

  disburseAmountPopup = () => {
    if (this.state.walletBalance) {
      const walletBalance = this.state.walletBalance;

      const data = {
        walletBalance: walletBalance,
        transferMode: this.state.transcardAccountState
          ? "ACH"
          : "Instant Transfer",
      };

      this.props.showNetAmountToUser({ data });
    }
    if (this.state.transcardAccountState || this.state.transcardCardState) {
      this.setState({
        disburseAmountPopupState: true,
      });
    } else {
      this.setState({
        disburseCardPopupState: true,
      });
    }
  };

  openDisbursePopup = () => {
    this.setState({
      disburseAmountPopupState: true,
    });
  };

  closeDisbursePopup = () => {
    this.setState({
      disburseAmountPopupState: false,
    });
  };

  openCardDisbursePopup = () => {
    this.setState({
      disburseCardPopupState: true,
    });
  };

  closeCardDisbursePopup = () => {
    this.setState({
      disburseCardPopupState: false,
    });
  };

  disburseAmount = () => {
    const walletBalance = this.state.walletBalance;
    this.setState({
      disburseAmountPopupState: false,
      isLoading: true,
    });

    const data = {
      debitedAmount: walletBalance,
      userId: localStorage.getItem("userId"),
      transferMode: this.state.transcardAccountState
      ? "ACH"
      : "Instant Transfer",
    };

    this.props.disbursePayment({ data });
  };

  validateResidence(data) {
    const errorsResidence = {};
    if (!data.rSinceFrom) {
      errorsResidence.rSinceFrom = "Since from is Required";
      errorsResidence.rSinceFromError = true;
    }
    if (!data.rSinceTo) {
      errorsResidence.rSinceTo = "Since to is Required";
      errorsResidence.rSinceToError = true;
    }
    if (!data.rState) {
      errorsResidence.rState = "State is Required";
      errorsResidence.rStateError = true;
    }
    return {
      errorsResidence,
      isValidResidence: isEmpty(errorsResidence),
    };
  }

  handleChange = (event, newValue) => {
    this.setState({
      value: newValue,
    });
  };

  handleCheckBoxFirstStep = () => {
    if (this.state.checkboxState == false) {
      this.setState({
        checkboxState: true,
        errorCheckbox: false,
      });
    } else {
      this.setState({
        checkboxState: false,
        errorCheckbox: true,
      });
    }
  };

  validateInputConsumer(data) {
    const errors = {};
    if (!data.cFirstName) {
      errors.cFirstName = "First name is Required";
      errors.cFirstNameError = true;
    } else if (data.cFirstName.length < 2) {
      errors.cFirstName = "Please enter at least 2 characters";
      errors.cFirstNameError = true;
    }
    if (data.cEmployer === "") {
      errors.cEmployer = "Employer name is Required";
      errors.cEmployerError = true;
    } else if (data.cEmployer.length < 2) {
      errors.cEmployer = "Please enter at least 2 characters";
      errors.cEmployerError = true;
    }
    if (data.cEmail !== "") {
      const isemailVerified = this.props.data.emailVerifyData;
      if (this.state.cEmail !== this.state.oldEmail) {
        if (Object.keys(isemailVerified).length > 0) {
          if (
            isemailVerified.collectMessage.messageShort ===
            "User email already exist"
          ) {
            errors.cEmail =
              "This user's email address has already been added to Collectively";
          }
        }
      }
    }

    if (!Validator.isEmail(data.cEmail)) {
      errors.cEmail = "Email is Not Valid";
      errors.cEmailError = true;
    }

    if (!data.cLastName) {
      errors.cLastName = "Last Name is Required";
      errors.cLastNameError = true;
    } else if (data.cLastName.length < 2) {
      errors.cLastName = "Please enter at least 2 characters";
      errors.cLastNameError = true;
    }
    if (!data.cPhone) {
      errors.cPhone = "Mobile number is Required";
      errors.cPhoneError = true;
    } else if (
      data.cPhone.replace(/\s/g, "").replace(/[_-]/g, "").length !== 10
    ) {
      errors.cPhone = "Please enter at least 10 digit";
      errors.cPhoneError = true;
    }

    return {
      errors,
      isValidConsumer: isEmpty(errors),
    };
  }

  linkAccountPopup = (e) => {
    if (e == "addNewAccount") {
      this.setState({
        nextButtonStepActive: true,
        addNewAccWithoutAdd: "addNewAccount",
        value: "3",
        address1PopupError: "",
        cityPopupError: "",
        statePopupError: "",
        zipPopupError: "",
        addMultipleAccountState: true,
      });
    } else {
      this.setState({
        linkAccountStep1: true,
        // linkCardAccountStep1: true,
        addNewAccWithoutAdd: "",
        addMultipleAccountState: e == "addNewLinkAccount" ? false : true,
      });
    }
  };

  addedBankReviewPopup = (e) => {
    this.setState({
      bankAccountConfirmationPopup: true,
    });
  };

  linkCardPopup = (e) => {
    if (e == "addNewAccount") {
      this.setState({
        nextButtonStepActive: true,
        addNewCardWithoutAdd: "addNewCard",
        value: "3",
        linkCardAccountStep1: true,
        addMultipleCardState: true,
      });
    } else {
      this.setState({
        // linkAccountStep1: true,
        linkCardAccountStep1: true,
        addNewCardWithoutAdd: "",
        linkCardAccountStep1: true,
        addMultipleCardState: e == "addNewLinkCard" ? false : true,
      });
    }
  };

  addedCardReviewPopup = (e) => {
    this.setState({
      // bankAccountConfirmationPopup: true,
      bankCardConfirmationPopup: true,
    });
  };

  viewAccountsPopup = () => {
    this.setState({
      viewAccountState: true,
      disburseAmountPopupState: false,
    });
    this.props.getAddedBankAccountsForUser(localStorage.getItem("userId"));
  };

  /**
   * Submit Consumer Form
   */
  handleSubmitConsumer(e) {
    e.preventDefault();
    if (this.isValidConsumer()) {
      this.setState({
        errors: {},
        ConsumerUpdateProfileDataStatus: true,
        isLoading: true,
      });
      this.props.updateConsumerUser(this.state);
    }
  }

  closeInstantPopup = () => {
    this.setState({
      instantTransferPopupState: false,
      cardNumber: "",
      cardMonth: "",
      cardYear: "",
      cardCvv: "",
      cardFirstName: "",
      cardNickName: "",
      cardLastName: "",
      cardLastNameError: "",
      cardFirstNameError: "",
      achState: false,
      instantTransferState: false,
      cardErrors: {
        cardMonthError: true,
        cardNumberError: true,
      },

      cardErrorsState: {
        cardMonthError: true,
        cardNumberError: true,
      },
      cardValue: "1",
      address1CardPopup: "",
      address2CardPopup: "",
      cityCardPopup: "",
      zipCardPopup: "",
      address1CardPopupError: "",
      address2CardPopupError: "",
      cityCardPopupError: "",
      zipCardPopupError: "",
      zipCardCodeError: "",
    });
  };

  handleSubmitResidences(e) {
    e.preventDefault();
    if (this.isValidResidence()) {
      this.setState({ errorsResidence: {}, isLoading: true });
      this.props.saveResidences(this.state);
    }
  }

  handleUpdateResidences(e) {
    e.preventDefault();
    if (this.isValidResidence()) {
      this.setState({ errorsResidence: {}, isLoading: true });

      this.props.viewResidencesData(this.state);
    }
  }

  AckOnchange(e) {
    this.setState({ [e.target.name]: e.target.value });
  }

  handleSeletcedYearChangeConsumer(date) {
    this.setState({ cSince: date });
  }

  openModal() {
    this.setState({ modalIsOpen: true });
  }

  openModalResidences() {
    this.setState({
      modalIsOpenResidences: true,
      saveAddress: true,
      showSaveButtonR: true,
      showUpadeButtonR: false,
      rState: "",
      rSinceFrom: "",
      rSinceTo: "",
      primaryFlag: "",
      errorsResidence: {},
    });
  }

  closeModalResidences() {
    this.setState({
      modalIsOpenResidences: false,
      linkAccountStep1: false,
      linkCardAccountStep1: false,
      viewAccountState: false,
      addAccountStep1: false,
      addCardAccountStep1: false,
      saveAddress: false,
      errorsResidence: {},
      openEditModel: false,
      openEditCardModel: false,
      bankAccountConfirmationPopup: false,
      // nextButtonStepActive: false,
      nextCardButtonStepActive: false,
      achState: false,
      instantTransferState: false,
      radioAccountValue: "",
      radioAddedAccountChecked: false,
      cardValue: "1",
      address1CardPopup: "",
      address2CardPopup: "",
      cityCardPopup: "",
      zipCardPopup: "",
      address1CardPopupError: "",
      address2CardPopupError: "",
      cityCardPopupError: "",
      zipCardPopupError: "",
      zipCardCodeError: "",
      bankCardConfirmationPopup: false,
      radioAddedCardChecked: false,
      radioCardValue: "",
      radioAccountValue: "",
    });
  }

  closeModal() {
    this.setState({ modalIsOpen: false });
  }

  componentWillUnmount() {
    this.props.clearDataEmail();
  }

  handleShowDeleteConfirmation = () => {
    this.setState({
      showDeleteConfirmation: !this.state.showDeleteConfirmation,
    });
  };

  UNSAFE_componentWillReceiveProps(newProps) {
    let linkCode = newProps.recieveLinkAccountProfile.code;
    let linkCardCode = newProps.receiveTranscardCardApi.code;
    if (
      newProps.receiveGetAllBankAccountsForUser &&
      newProps.receiveGetAllBankAccountsForUser.data.code == "400"
    ) {
      this.setState({
        hasAnyActiveAccount: false,
        noAccountLinked: true,
      });
    }

    if (
      newProps.receiveGetAllAddedCardsForUser &&
      newProps.receiveGetAllAddedCardsForUser.data.code == "400"
    ) {
      this.setState({
        hasAnyActiveCard: false,
        noCardLinked: true,
      });
    }

    if (
      this.props.receiveGetAllBankAccountsForUser &&
      this.props.receiveGetAllBankAccountsForUser.data &&
      this.props.receiveGetAllBankAccountsForUser.data.code == "400" &&
      this.props.receiveGetAddedBankAccountsForUser &&
      this.props.receiveGetAddedBankAccountsForUser.code == "400"
    ) {
      this.setState({
        userHasNoAccounts: true,
        transcardAccountState: false,
      });
    } else {
      this.setState({
        userHasNoAccounts: false,
      });
    }

    if (
      this.props.receiveGetAllAddedCardsForUser &&
      this.props.receiveGetAllAddedCardsForUser.data &&
      this.props.receiveGetAllAddedCardsForUser.data.code == "400" &&
      this.props.receiveGetAddedCardsForUser &&
      this.props.receiveGetAddedCardsForUser.code == "400"
    ) {
      this.setState({
        userHasNoCards: true,
        transcardCardState: false,
      });
    } else {
      this.setState({
        userHasNoAccounts: false,
      });
    }

    if (
      newProps.receiveGetAllBankAccountsForUser &&
      newProps.receiveGetAllBankAccountsForUser.data &&
      newProps.receiveGetAllBankAccountsForUser.data.code == 200
    ) {
      this.setState({
        userHasNoAccounts: false,
        AddNewBankAccountState: true,
        cardAlreadyLinked: true,
        // hasAnyActiveAccount: false,
        noAccountLinked: false,
      });
    }

    if (
      newProps.receiveGetAllAddedCardsForUser &&
      newProps.receiveGetAllAddedCardsForUser.data &&
      newProps.receiveGetAllAddedCardsForUser.data.code == 200
    ) {
      this.setState({
        userHasNoCards: false,
        AddNewCardState: true,
        cardAlreadyLinked: true,
        // hasAnyActiveAccount: false,
        noCardLinked: false,
      });
    }

    if (
      newProps.receiveGetAddedBankAccountsForUser &&
      newProps.receiveGetAddedBankAccountsForUser.code &&
      newProps.receiveGetAddedBankAccountsForUser.code == "200" &&
      newProps.receiveGetAddedBankAccountsForUser.result &&
      newProps.receiveGetAddedBankAccountsForUser.result.length > 0
    ) {
      this.setState({
        transcardAccountState: true,
        transcardCardState: false,
        hasAnyActiveAccount: true,
        noAccountLinked: false,
      });
    }

    if (
      newProps.receiveGetAddedCardsForUser &&
      newProps.receiveGetAddedCardsForUser.code &&
      newProps.receiveGetAddedCardsForUser.code == "200" &&
      newProps.receiveGetAddedCardsForUser.result &&
      newProps.receiveGetAddedCardsForUser.result.length > 0
    ) {
      this.setState({
        transcardCardState: true,
        transcardAccountState: false,
        hasAnyActiveCard: true,
        noCardLinked: false,
      });
    }

    let paymentHistory = newProps.data.receiveGetUserTransactionsHistory;
    if (
      paymentHistory &&
      paymentHistory.data &&
      paymentHistory.data.code == "200"
    ) {
      this.setState({
        paymentHistoryState: paymentHistory,
      });
    }

    if (
      newProps.receiveUpdateBankAccountDetails.data &&
      newProps.receiveUpdateBankAccountDetails.data.code == "200" &&
      this.state.isLoading == true
    ) {
      this.setState({
        isLoading: false,
        openEditModel: false,
      });
      toast.success(
        newProps.receiveUpdateBankAccountDetails.data.collectMessage
          .messageShort,
        {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        }
      );
      this.props.getAddedBankAccountsForUser(localStorage.getItem("userId"));
      this.props.clearReceiveUpdateBankAccountDetails();
    }
    if (
      newProps.receiveUpdateCardDetails.data &&
      newProps.receiveUpdateCardDetails.data.code == "200" &&
      this.state.isLoading == true
    ) {
      this.setState({
        isLoading: false,
        openEditCardModel: false,
      });
      toast.success(
        newProps.receiveUpdateCardDetails.data.collectMessage.messageShort,
        {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        }
      );
      this.props.getAddedCardsForUser(localStorage.getItem("userId"));
      this.props.clearReceiveUpdateCardDetails();
    }
    if (
      this.props.receiveGetAddedBankAccountsForUser &&
      this.props.receiveGetAddedBankAccountsForUser.code == "200"
    ) {
      console.log("200");
      this.setState({
        bankName: this.props.receiveGetAddedBankAccountsForUser.result[0]
          .accountDisplayName,
        bankId: this.props.receiveGetAddedBankAccountsForUser.result[0].id,
        AddNewBankAccountState: false,
        transcardAccountState: true,
      });
    }

    if (
      this.props.receiveGetAddedCardsForUser &&
      this.props.receiveGetAddedCardsForUser.code == "200"
    ) {
      console.log("200");
      this.setState({
        cardNickName: this.props.receiveGetAddedCardsForUser.result[0]
          .cardNickName,
        cardId: this.props.receiveGetAddedCardsForUser.result[0].id,
        AddNewCardState: false,
        transcardCardState: true,
      });
    }

    if (
      newProps.receiveGetAddedCardsForUser &&
      newProps.receiveGetAddedCardsForUser.code == "400"
    ) {
      this.setState({
        AddNewCardState: true,
        hasAnyActiveCard: false,
        // noCardLinked: false,
      });
    }

    if (
      newProps.receiveGetAddedBankAccountsForUser &&
      newProps.receiveGetAddedBankAccountsForUser.code == "400"
    ) {
      this.setState({
        AddNewBankAccountState: true,
        hasAnyActiveAccount: false,
        // noAccountLinked: false,
      });
    }

    if (newProps.receiveSetDefaultBankAccount) {
      if (
        (this.props.receiveSetDefaultBankAccount &&
          !this.props.receiveSetDefaultBankAccount.config &&
          newProps.receiveSetDefaultBankAccount.config &&
          newProps.receiveSetDefaultBankAccount.config.data) ||
        (this.props.receiveSetDefaultBankAccount &&
          this.props.receiveSetDefaultBankAccount.setAt !=
            newProps.receiveSetDefaultBankAccount.setAt)
      ) {
        this.setState({
          transcardAccount: true,
          achState: false,
          instantTransferState: false,
        });
        toast.success(
          newProps.receiveSetDefaultBankAccount.data &&
            newProps.receiveSetDefaultBankAccount.data.collectMessage
              .messageShort,
          {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          }
        );
        this.props.getAddedBankAccountsForUser(localStorage.getItem("userId"));
      }
    }

    if (newProps.receiveSetDefaultCard) {
      if (
        (this.props.receiveSetDefaultCard &&
          !this.props.receiveSetDefaultCard.config &&
          newProps.receiveSetDefaultCard.config &&
          newProps.receiveSetDefaultCard.config.data) ||
        (this.props.receiveSetDefaultCard &&
          this.props.receiveSetDefaultCard.setAt !=
            newProps.receiveSetDefaultCard.setAt)
      ) {
        this.setState({
          transcardCardState: true,
          achState: false,
          instantTransferState: false,
          radioAddedCardChecked: false,
        });
        toast.success(
          newProps.receiveSetDefaultCard.data &&
            newProps.receiveSetDefaultCard.data.collectMessage.messageShort,
          {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          }
        );
        this.props.getAddedCardsForUser(localStorage.getItem("userId"));
      }
    }

    if (newProps.receiveDeleteUserCard) {
      if (
        (this.props.receiveDeleteUserCard &&
          !this.props.receiveDeleteUserCard.config &&
          newProps.receiveDeleteUserCard.config &&
          newProps.receiveDeleteUserCard.config.data) ||
        (this.props.receiveDeleteUserCard &&
          this.props.receiveDeleteUserCard.setAt !=
            newProps.receiveDeleteUserCard.setAt)
      ) {
        this.setState({
          radioAddedAccountChecked: false,
          radioCardValue: "",
          achState: false,
          instantTransferState: false,
        });
        toast.success(
          newProps.receiveDeleteUserCard.data &&
            newProps.receiveDeleteUserCard.data.collectMessage.messageShort,
          {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          }
        );
        this.props.getAddedCardsForUser(localStorage.getItem("userId"));
        this.props.getAllAddedCardsForUser(localStorage.getItem("userId"));
      }
    }

    if (newProps.receiveDeleteUserBankAccount) {
      if (
        (this.props.receiveDeleteUserBankAccount &&
          !this.props.receiveDeleteUserBankAccount.config &&
          newProps.receiveDeleteUserBankAccount.config &&
          newProps.receiveDeleteUserBankAccount.config.data) ||
        (this.props.receiveDeleteUserBankAccount &&
          this.props.receiveDeleteUserBankAccount.setAt !=
            newProps.receiveDeleteUserBankAccount.setAt)
      ) {
        this.setState({
          radioAddedAccountChecked: false,
          radioAccountValue: "",
          achState: false,
          instantTransferState: false,
        });
        toast.success(
          newProps.receiveDeleteUserBankAccount.data &&
            newProps.receiveDeleteUserBankAccount.data.collectMessage
              .messageShort,
          {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          }
        );
        this.props.getAddedBankAccountsForUser(localStorage.getItem("userId"));
        this.props.getAllBankAccountsForUser(localStorage.getItem("userId"));
      }
    }

    // Ths conditions has to be examined

    // if (
    //   this.state.transcardAccountState != true ||
    //   !newProps.data.BusinessUserProfileData.transcardAccount
    // ) {
    //   !newProps.data.BusinessUserProfileData.transcardAccount ||
    //   newProps.data.ConsumerUserData.transcardAccount == "No"
    //     ? this.setState({ transcardAccountState: false })
    //     : this.setState({ transcardAccountState: true });
    // }

    if (newProps.recieveGetTranscardPaymentMethods) {
      this.setState({
        showLinkButton: true,
      });
    }
    if (
      !this.props.recieveDisburseAmount.code &&
      newProps.recieveDisburseAmount.code
    ) {
      if (newProps.recieveDisburseAmount.code == "200") {
        this.setState(
          {
            transferFundsToACHState:
              this.state.transcardAccountState == true ? true : false,
            transferFundsToCardState:
              this.state.transcardCardState == true ? true : false,
          },
          () => {
            const data = {
              userId: localStorage.getItem("userId"),
              paymentId: newProps.recieveDisburseAmount.result,
              debitedAmount: this.state.walletBalance,
              transferMode: this.state.transcardAccountState
              ? "ACH"
              : "Instant Transfer",
            };
            if (
              this.state.transcardAccountState == true &&
              this.state.transcardCardState == false
            ) {
              this.props.transferFundsToACH({ data });
            }
            if (
              this.state.transcardAccountState == false &&
              this.state.transcardCardState == true
            ) {
              this.props.transferFundsToCard({ data });
            }
          }
        );
      } else if (
        newProps.data.recieveDisburseAmount.code == "400" &&
        this.state.isLoading == true
      ) {
        this.setState({
          isLoading: false,
        });
        toast.error("Some Error Occurred", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    }

    if (
      this.state.transferFundsToCardState &&
      newProps.receiveTransferFundsToCard
    ) {
      if (
        newProps.receiveTransferFundsToCard.code == "200" &&
        this.state.debitWalletBalanceState !== true
      ) {
        this.setState(
          {
            debitWalletBalanceState: true,
          },
          () => {
            this.props.getDebitWalletBalance({
              userId: localStorage.getItem("userId"),
              debitedAmount: this.state.walletBalance,
              transferMode: this.state.transcardAccountState
                ? "ACH"
                : "Instant Transfer",
            });
          }
        );
      } else if (
        newProps.data.receiveTransferFundsToCard.code == "400" &&
        this.state.isLoading == true
      ) {
        this.setState({
          isLoading: false,
        });
        toast.error("Some Error Occurred", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    }

    if (
      this.state.transferFundsToACHState &&
      newProps.receiveTransferFundsToACH
    ) {
      if (
        newProps.receiveTransferFundsToACH.code == "200" &&
        this.state.debitWalletBalanceState !== true
      ) {
        this.setState(
          {
            debitWalletBalanceState: true,
          },
          () => {
            this.props.getDebitWalletBalance({
              userId: localStorage.getItem("userId"),
              debitedAmount: this.state.walletBalance,
              transferMode: this.state.transcardAccountState
                ? "ACH"
                : "Instant Transfer",
            });
          }
        );
      } else if (
        newProps.data.receiveTransferFundsToACH.code == "400" &&
        this.state.isLoading == true
      ) {
        this.setState({
          isLoading: false,
        });
        toast.error("Some Error Occurred", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    }
    if (
      this.state.debitWalletBalanceState &&
      newProps.data.getDebitWalletBalance
    ) {
      if (newProps.data.getDebitWalletBalance.code == "200") {
        this.setState({
          isLoading: false,
          debitWalletBalanceState: false,
          transferFundsToACHState: false,
          transferFundsToCardState: false,
        });
        toast.success("Funds Successfully Transfered", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        this.props.getUserTransactionsHistory(localStorage.getItem("userId"));
        this.props.clearRecieveDisburseAmount();
        this.props.clearReceiveTransferFundsToACH();
        this.props.clearReceiveTransferFundsToCard();
        this.props.cleargetDebitWalletBalance();
      } else if (
        newProps.data.getDebitWalletBalance.code == "400" &&
        this.state.isLoading == true
      ) {
        this.setState({
          isLoading: false,
        });
        toast.error("Some Error Occurred", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    }
    if (
      this.props.recieveLinkAccountProfile.setAt !==
      newProps.recieveLinkAccountProfile.setAt
    ) {
      if (linkCode && linkCode != "undefined") {
        if (linkCode == "200") {
          this.setState(
            {
              // linkAccountStep1: false,
              // nextButtonStepActive: false,
              transcardAccountState: true,
              transcardAccountState: false,
              addUserBankAccountState: true,
              noAccountLinked: false,
              hasAnyActiveAccount: true,
            },
            () => {
              const data = {
                userId: localStorage.getItem("userId"),
                accountHolderName: this.state.accountHolderName,
                accountNumber: this.state.accountNumber,
                routingNumber: this.state.routingNumber,
                accountType: this.state.accountType,
                displayName: this.state.displayName,
              };
              this.props.addUserBankAccount({ data });
            }
          );
        }
        if (linkCode == "400") {
          this.setState(
            {
              isLoading: false,
              linkAccountStep1: false,
              linkCardAccountStep1: false,
              addAccountStep1: false,
              addCardAccountStep1: false,
              bankAccountConfirmationPopup: false,
              addMultipleAccountState: false,
              checkboxState: false,
              viewAccountState: false,
              errorCheckbox: true,
              accountHolderName: "",
              accountNumber: "",
              routingNumber: "",
              accountType: "",
              displayName: "",
              value: "1",
              routingNumberError: "",
              accountNumberError: "",
              address1Popup: "",
              address2Popup: "",
              cityPopup: "",
              statePopup: "",
              statePopupError: "",
              stateCardPopupError: "",
              stateCardPopup: "",
              zipPopup: "",
              address1PopupError: "",
              address2PopupError: "",
              cityPopupError: "",
              zipPopupError: "",
              zipCodeError: "",
              stateError: "",
              statePopupName: "",
              stateCardPopupName: "",
              cardValue: "1",
              address1CardPopup: "",
              address2CardPopup: "",
              cityCardPopup: "",
              zipCardPopup: "",
              address1CardPopupError: "",
              address2CardPopupError: "",
              cityCardPopupError: "",
              zipCardPopupError: "",
              zipCardCodeError: "",
              achState: false,
              instantTransferState: false,
              addressNextButton: false,
              addressCardNextButton: false,
              nextButtonStepActive: false,
              nextCardButtonStepActive: false,
              cardFirstName: "",
              cardFirstNameError: false,
              cardLastName: "",
              cardLastNameError: false,
              cardNickName: "",
              cardNickNameError: false,
              cardNumber: "",
              cardNumberError: false,
              cardMonth: "",
              cardMonthError: false,
              cardYear: "",
              cardYearError: false,
              cardCvv: "",
              cardCvvError: false,
              noAccountLinked: true,
            },
            () => {
              toast.error(
                "Transcard account already exists. Please make new account.",
                {
                  position: "top-right",
                  autoClose: 5000,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                }
              );
            }
          );
        }
      }
    }
    if (
      this.props.receiveTranscardCardApi.setAt !==
      newProps.receiveTranscardCardApi.setAt
    ) {
      if (linkCardCode && linkCardCode != "undefined") {
        if (linkCardCode == "200") {
          let cardExpirationDate = `20${this.state.cardYear}-${this.state.cardMonth}`;
          this.setState(
            {
              // linkAccountStep1: false,
              // nextButtonStepActive: false,
              transcardCardState: true,
              transcardAccountState: false,
              addUserCardState: true,
              noCardLinked: false,
              hasAnyActiveCard: true,
            },
            () => {
              const data = {
                userId: localStorage.getItem("userId"),
                cvc: this.state.cardCvv,
                firstName: this.state.cardFirstName,
                lastName: this.state.cardLastName,
                cardNumber: this.state.cardNumber
                  .replace(/_/g, "")
                  .replace(/ /g, ""),
                cardNickName: this.state.cardNickName,
                cardExpirationDate: cardExpirationDate,
                streeAddress: this.state.address1CardPopup,
                streetAddress2: this.state.address2CardPopup,
                city: this.state.cityCardPopup,
                zipCode: this.state.zipCardPopup,
              };
              this.props.addUserCard({ data });
            }
          );
        }
        if (linkCardCode == "400") {
          this.setState(
            {
              isLoading: false,
              linkAccountStep1: false,
              linkCardAccountStep1: false,
              addAccountStep1: false,
              addCardAccountStep1: false,
              bankAccountConfirmationPopup: false,
              addMultipleAccountState: false,
              checkboxState: false,
              viewAccountState: false,
              errorCheckbox: true,
              accountHolderName: "",
              accountNumber: "",
              routingNumber: "",
              accountType: "",
              displayName: "",
              value: "1",
              routingNumberError: "",
              accountNumberError: "",
              address1Popup: "",
              address2Popup: "",
              cityPopup: "",
              statePopup: "",
              statePopupError: "",
              stateCardPopupError: "",
              stateCardPopup: "",
              zipPopup: "",
              address1PopupError: "",
              address2PopupError: "",
              cityPopupError: "",
              zipPopupError: "",
              zipCodeError: "",
              stateError: "",
              statePopupName: "",
              stateCardPopupName: "",
              cardValue: "1",
              address1CardPopup: "",
              address2CardPopup: "",
              cityCardPopup: "",
              zipCardPopup: "",
              address1CardPopupError: "",
              address2CardPopupError: "",
              cityCardPopupError: "",
              zipCardPopupError: "",
              zipCardCodeError: "",
              achState: false,
              instantTransferState: false,
              addressNextButton: false,
              addressCardNextButton: false,
              nextButtonStepActive: false,
              nextCardButtonStepActive: false,
              cardFirstName: "",
              cardFirstNameError: false,
              cardLastName: "",
              cardLastNameError: false,
              cardNickName: "",
              cardNickNameError: false,
              cardNumber: "",
              cardNumberError: false,
              cardMonth: "",
              cardMonthError: false,
              cardYear: "",
              cardYearError: false,
              cardCvv: "",
              cardCvvError: false,
              noCardLinked: true,
            },
            () => {
              toast.error(
                "Transcard account already exists. Please make new account.",
                {
                  position: "top-right",
                  autoClose: 5000,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                }
              );
            }
          );
        }
      }
    }

    if (
      (this.state.addUserCardState && newProps.receiveAddUserCard) ||
      (newProps.receiveAddUserCard && this.state.addNewCardWithoutAdd != "")
    ) {
      console.log("newProps.receiveAddUserCard", newProps.receiveAddUserCard);
      if (
        // !this.props.receiveAddUserCard.code &&
        newProps.receiveAddUserCard.data &&
        newProps.receiveAddUserCard.data.code &&
        newProps.receiveAddUserCard.data.code == "200" 
      ) {
        this.props.getAddedCardsForUser(localStorage.getItem("userId"));
        this.props.getAllAddedCardsForUser(localStorage.getItem("userId"));
        this.setState({
          linkAccountStep1: false,
          linkCardAccountStep1: false,
          nextCardButtonStepActive: false,
          addUserCardState: false,
          transcardCardState: true,
          isLoading: false,
          isCreatedCard: true,
          AddNewCardState: false,
          addAccountStep1: false,
          addCardAccountStep1: false,
          bankAccountConfirmationPopup: false,
          addMultipleAccountState: false,
          checkboxState: false,
          viewAccountState: false,
          errorCheckbox: true,
          accountHolderName: "",
          accountNumber: "",
          routingNumber: "",
          accountType: "",
          displayName: "",
          value: "1",
          routingNumberError: "",
          accountNumberError: "",
          address1Popup: "",
          address2Popup: "",
          cityPopup: "",
          statePopup: "",
          statePopupError: "",
          stateCardPopupError: "",
          stateCardPopup: "",
          zipPopup: "",
          address1PopupError: "",
          address2PopupError: "",
          cityPopupError: "",
          zipPopupError: "",
          zipCodeError: "",
          stateError: "",
          statePopupName: "",
          stateCardPopupName: "",
          cardValue: "1",
          address1CardPopup: "",
          address2CardPopup: "",
          cityCardPopup: "",
          zipCardPopup: "",
          address1CardPopupError: "",
          address2CardPopupError: "",
          cityCardPopupError: "",
          zipCardPopupError: "",
          zipCardCodeError: "",
          achState: false,
          instantTransferState: false,
          addressNextButton: false,
          addressCardNextButton: false,
          nextButtonStepActive: false,
          cardFirstName: "",
          cardFirstNameError: false,
          cardLastName: "",
          cardLastNameError: false,
          cardNickName: "",
          cardNickNameError: false,
          cardNumber: "",
          cardNumberError: false,
          cardMonth: "",
          cardMonthError: false,
          cardYear: "",
          cardYearError: false,
          cardCvv: "",
          cardCvvError: false,
          noCardLinked: true,
        });
        toast.success("Card successfully linked!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        this.props.clearReceiveAddUserCard();
      } else if (linkCardCode == "400") {
        this.setState({
          isLoader: false,
        });
      }
      if (
        newProps.receiveAddUserCard.data &&
        newProps.receiveAddUserCard.data.code &&
        newProps.receiveAddUserCard.data.code == "406"
      ) {
        this.setState({
          linkAccountStep1: false,
          linkCardAccountStep1: false,
          nextCardButtonStepActive: false,
          addUserCardState: false,
          transcardCardState: true,
          isLoading: false,
          isCreatedCard: true,
          AddNewCardState: false,
          addAccountStep1: false,
          addCardAccountStep1: false,
          bankAccountConfirmationPopup: false,
          addMultipleAccountState: false,
          checkboxState: false,
          viewAccountState: false,
          errorCheckbox: true,
          accountHolderName: "",
          accountNumber: "",
          routingNumber: "",
          accountType: "",
          displayName: "",
          value: "1",
          routingNumberError: "",
          accountNumberError: "",
          address1Popup: "",
          address2Popup: "",
          cityPopup: "",
          statePopup: "",
          statePopupError: "",
          stateCardPopupError: "",
          stateCardPopup: "",
          zipPopup: "",
          address1PopupError: "",
          address2PopupError: "",
          cityPopupError: "",
          zipPopupError: "",
          zipCodeError: "",
          stateError: "",
          statePopupName: "",
          stateCardPopupName: "",
          cardValue: "1",
          address1CardPopup: "",
          address2CardPopup: "",
          cityCardPopup: "",
          zipCardPopup: "",
          address1CardPopupError: "",
          address2CardPopupError: "",
          cityCardPopupError: "",
          zipCardPopupError: "",
          zipCardCodeError: "",
          achState: false,
          instantTransferState: false,
          addressNextButton: false,
          addressCardNextButton: false,
          nextButtonStepActive: false,
          cardFirstName: "",
          cardFirstNameError: false,
          cardLastName: "",
          cardLastNameError: false,
          cardNickName: "",
          cardNickNameError: false,
          cardNumber: "",
          cardNumberError: false,
          cardMonth: "",
          cardMonthError: false,
          cardYear: "",
          cardYearError: false,
          cardCvv: "",
          cardCvvError: false,
          noCardLinked: true,
        });
        toast.error("Display Name should be different than previous ones", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        this.props.clearReceiveAddUserCard();
      }
    }

    if (
      (this.state.addUserBankAccountState &&
        newProps.receiveAddUserBankAccountApi) ||
      (newProps.receiveAddUserBankAccountApi &&
        this.state.addNewAccWithoutAdd != "")
    ) {
      if (
        !this.props.receiveAddUserBankAccountApi.code &&
        newProps.receiveAddUserBankAccountApi.code &&
        // this.state.isCreated == false &&
        newProps.receiveAddUserBankAccountApi.code != "406"
      ) {
        this.props.getAddedBankAccountsForUser(localStorage.getItem("userId"));
        this.props.getAllBankAccountsForUser(localStorage.getItem("userId"));
        this.setState({
          linkAccountStep1: false,
          linkCardAccountStep1: false,
          nextButtonStepActive: false,
          transcardAccountState: true,
          isLoading: false,
          isCreated: true,
          checkboxState: false,
          errorCheckbox: true,
          accountHolderName: "",
          accountNumber: "",
          routingNumber: "",
          accountType: "",
          displayName: "",
          value: "1",
          routingNumberError: "",
          accountNumberError: "",
          AddNewBankAccountState: false,
          nextButtonStepActive: false,
          achState: false,
          instantTransferState: false,
        });
        toast.success("Account successfully linked!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        this.props.clearReceiveAddUserBankAccountApi();
      }
    }  if (linkCode == "400") {
      this.setState({
        isLoader: false,
      });
    }  if (newProps.receiveAddUserBankAccountApi.code == "406") {
      this.setState({
        addAccountStep1: false,
        addMultipleAccountState: false,
        transcardAccountState: true,
        isLoading: false,
        checkboxState: false,
        errorCheckbox: true,
        accountHolderName: "",
        accountNumber: "",
        routingNumber: "",
        accountType: "",
        displayName: "",
        value: "1",
        routingNumberError: "",
        accountNumberError: "",
        nextButtonStepActive: false,
        achState: false,
        instantTransferState: false,
      });
      toast.error(
        newProps.receiveAddUserBankAccountApi.collectMessage.messageShort,
        {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        }
      );
      this.props.clearReceiveAddUserBankAccountApi();
    }
    // if (
    //   this.state.addMultipleAccountState &&
    //   newProps.receiveAddUserBankAccountApi
    // ) {
    //   if (newProps.receiveAddUserBankAccountApi.code == "200") {
    //     this.setState({
    //       addAccountStep1: false,
    //       addMultipleAccountState: false,
    //       transcardAccountState: true,
    //       isLoading: false,
    //       checkboxState: false,
    //       errorCheckbox: true,
    //       accountHolderName: "",
    //       accountNumber: "",
    //       routingNumber: "",
    //       accountType: "",
    //       displayName: "",
    //       value: "1",
    //       routingNumberError: "",
    //       accountNumberError: "",
    //       achState: false,
    //       instantTransferState: false,
    //     });
    //     toast.success(
    //       newProps.receiveAddUserBankAccountApi.collectMessage.messageShort,
    //       {
    //         position: "top-right",
    //         autoClose: 5000,
    //         hideProgressBar: false,
    //         closeOnClick: true,
    //         pauseOnHover: true,
    //         draggable: true,
    //         progress: undefined,
    //       }
    //     );
    //     this.props.getAddedBankAccountsForUser(localStorage.getItem("userId"));
    //     this.props.clearReceiveAddUserBankAccountApi();
    //   } else if (newProps.receiveAddUserBankAccountApi.code == "406") {
    //     this.setState({
    //       addAccountStep1: false,
    //       addMultipleAccountState: false,
    //       transcardAccountState: true,
    //       isLoading: false,
    //       checkboxState: false,
    //       errorCheckbox: true,
    //       accountHolderName: "",
    //       accountNumber: "",
    //       routingNumber: "",
    //       accountType: "",
    //       displayName: "",
    //       value: "1",
    //       routingNumberError: "",
    //       accountNumberError: "",
    //       nextButtonStepActive: false,
    //       achState: false,
    //       instantTransferState:false,
    //     });
    //     toast.error(
    //       newProps.receiveAddUserBankAccountApi.collectMessage.messageShort,
    //       {
    //         position: "top-right",
    //         autoClose: 5000,
    //         hideProgressBar: false,
    //         closeOnClick: true,
    //         pauseOnHover: true,
    //         draggable: true,
    //         progress: undefined,
    //       }
    //     );
    //     this.props.clearReceiveAddUserBankAccountApi();
    //   }
    // }
    // }
    // }
  }

  AckOnchangeText = (e) => {
    let value = "";
    if (e.target.name === "primaryFlag" && e.target.checked === true) {
      value = "Y";
    }
    this.setState({
      [e.target.name]: value,
    });
  };

  debitWalletBalance = async () => {
    const { getDebitWalletBalance } = this.props;
    const { walletBalance, userId } = this.state;
    this.setState({
      isLoading: true,
      modalIsDebite: false,
    });
    await getDebitWalletBalance({
      userId,
      debitedAmount: walletBalance,
      transferMode: this.state.transcardAccountState
        ? "ACH"
        : "Instant Transfer",
    });
    await this.props.getConsumerUser(localStorage.getItem("userId"));
  };

  debitAlert = () => {
    this.setState({
      modalIsDebite: true,
    });
    // confirmAlert({
    //   // title: 'Are you sure you want to debit this amount?',
    //   message: 'Are you sure you want to debit this amount?',
    //   buttons: [
    //     {
    //       label: 'Yes',
    //       onClick: this.debitWalletBalance,
    //     },
    //     {
    //       label: 'No',
    //     },
    //   ],
    // });
  };

  afterOpenModal = () => {
    // references are now sync'd and can be accessed.
    // this.subtitle.style.color = '#f00';
  };

  closeModalDebite = () => {
    this.setState({
      modalIsDebite: false,
    });
  };

  toggleHandlerOne = () => {
    const dual = this.state.tableState ;
    this.setState({tableState:!dual});
  }

  render() {
    let csvReport ;
    if(this.props.receiveGetUserTransactionsHistory.data && this.props.receiveGetUserTransactionsHistory.data.result !== undefined){        //2893 fix  pdf ,csv
      console.log("no",this.props.receiveGetUserTransactionsHistory.data);
      const data = [
        this.props.receiveGetUserTransactionsHistory.data.result.records.map(transactionHistory =>(
            {settlement: String(transactionHistory.settlementShortName), 
                grossamount: "$"+  String(transactionHistory.priceBreakupDto.totalAmount.toFixed(
                2)),
              collectivelyfee : "$"+ String(transactionHistory.priceBreakupDto.collectivelyCommissionAmount.toFixed(
                2
              )),
              transferfee : "$" +String(transactionHistory.priceBreakupDto.transferFee.toFixed(
                2
              )),
              type :  String(transactionHistory.transferMode) ,
              netamount :"$"+ String(transactionHistory.priceBreakupDto.userAmount.toFixed(
                2
              )),
              status: "COMPLETED" ,
              date : String(transactionHistory.amountTransferredDate)
            }
            
        ))
    ];
    const headers = [{
          label : "SETTLEMENT",key :"settlement"
      },
      {label:"GROSS AMOUNT",key:"grossamount"},
      {label:"COLLECTIVELY FEE",key:"collectivelyfee"},
      {label : "TRANSFER FEE",key : "transferfee"},
      {label : "TYPE" , key : "type"},
      {label:"NET AMOUNT" ,key : "netamount"},
      {label: "STATUS" ,key : "status"},
      {label:"DATE",key:"date"}
      ];
      console.log("data",data[0],headers,typeof data["settlement"])
        csvReport = {
          data: data[0],
          headers: headers,
          filename: 'Report.csv'
        };
        console.log("datat",csvReport)
    }
    const {
      file,
      errors,
      errorsResidence,
      privacyPolicyPath,
      agreementLetterPath,
      letterOfAgencyPath,
      rSinceFrom,
      rSinceTo,
      signatureFontFamily,
      signatureDefaultValue,
      cCountryCode,
      showUpadeButtonR,
      showSaveButtonR,
      cPhone,
      cEmployer,
      rState,
      cEmail,
      cFirstName,
      cLastName,
      consumerResidences,
      isLoading,
      primaryFlag,
      walletBalance,
      cardFirstName,
      cardLastName,
      cardNickName,
      cardErrors,
      cardNumber,
      cardMonth,
      cardYear,
      cardCvv,
    } = this.state;

    let loader1;
    if (isLoading) {
      loader1 = (
        <div className="loader">
          <img src={loader} alt="" />
        </div>
      );
    }
    const { AllStates, AllCountryData } = this.props.data;
    const options = [];
    options.push(
      <option disabled key={0} value="">
        State
      </option>
    );
    AllStates.map((item) =>
      options.push(
        <option key={item.stateId} value={item.stateId}>
          {item.stateName}
        </option>
      )
    );

    const optionsCountry = [];
    if (AllCountryData !== undefined) {
      AllCountryData.map((item) =>
        optionsCountry.push({
          value: item.countryCode,
          label: item.countryCode,
          name: item.countryCode,
        })
      );
    } else {
      optionsCountry.push({ value: "+1", label: "+1", name: "+1" });
    }
    const cSelectedCountry = _.find(optionsCountry, { value: cCountryCode });
    const cDefaultOptionCountry = cSelectedCountry;

    const optionsSince = [];
    optionsSince.push({ value: "", label: "From*", name: "Since From" });
    optionsSince.push({
      value: "Prior to 1990",
      label: "Prior to 1990",
      name: "Since",
    });

    const currentDate = new Date().getFullYear();
    for (let i = 1990; i <= currentDate; i++) {
      optionsSince.push({
        value: i.toString(),
        label: i.toString(),
        name: i.toString(),
      });
    }

    const optionsSince1 = [];
    optionsSince1.push({ value: "", label: "To*", name: "Since To" });
    optionsSince1.push({
      value: "Prior to 1990",
      label: "Prior to 1990",
      name: "Since",
    });

    for (let i = 1990; i <= currentDate; i++) {
      optionsSince1.push({
        value: i.toString(),
        label: i.toString(),
        name: i.toString(),
      });
    }
    // selecting the first index to select
    const cSelectedSince1 = _.find(optionsSince, { value: rSinceFrom });
    const cDefaultSince1 = cSelectedSince1;

    const cSelectedSince2 = _.find(optionsSince1, { value: rSinceTo });
    const cDefaultSince2 = cSelectedSince2;

    return (
      <div className="wp-tab-container">
        <h3 className="p-w-h3">Profile</h3>

        <Tabs>
          <TabList>
            <Tab>Settings</Tab>
            <Tab
              className={
                this.state.walletBalance != 0
                  ? "react-tabs__tab greenDotActive"
                  : "react-tabs__tab"
              }
            >
              Wallet
            </Tab>
          </TabList>
          <TabPanel>
            <span>
              <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
              />
              {loader1}

              <Modal
                shouldCloseOnOverlayClick={false}
                isOpen={this.state.modalIsDebite}
                onAfterOpen={this.afterOpenModal}
                onRequestClose={this.closeModalDebite}
                style={customStyles}
                contentLabel="test"
                ariaHideApp={false}
              >
                <div className="modal-content addvehicle-content">
                  <div className="col s12 m7">
                    <h4> Wallet </h4>
                  </div>
                  <div className="col s12">
                    <div className="grey-box">
                      <div className="grey-inner">
                        <p> Are you sure you want to debit this amount ?</p>
                        <button
                          onClick={this.debitWalletBalance}
                          className="btn waves-effect waves-light primary-btn col s12 m6 offset-m3 update-profile"
                          type="submit"
                          name="action"
                        >
                          Yes
                          <i className="material-icons">arrow_forward</i>
                        </button>

                        <button
                          onClick={this.closeModalDebite}
                          style={{ marginLeft: "5px" }}
                          className="btn waves-effect waves-light primary-btn col s12 m6 offset-m3 update-profile"
                          type="submit"
                          name="action"
                        >
                          No
                          <i className="material-icons">arrow_forward</i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </Modal>

              {/* Linked Bank Account Popup  Starts Here*/}

              <Modal
                isOpen={this.state.viewAccountState}
                onAfterOpen={this.afterOpenModal}
                onRequestClose={this.closeModalResidences}
                style={linkedAccCustomStyles}
                contentLabel="test"
                ariaHideApp={false}
              >
                <div className="lined-acc-table">
                  <h3 className="popupAddBank">Linked Accounts</h3>

                  <table className="table-simple">
                    <thead>
                      <tr>
                        <th>Display Name</th>
                        <th>Added on</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.props.receiveGetAddedBankAccountsForUser &&
                        this.props.receiveGetAddedBankAccountsForUser.code ==
                          "200" &&
                        this.props.receiveGetAddedBankAccountsForUser.result.map(
                          (bankAcc) => (
                            <tr>
                              <td data-column="Display Name">
                                {bankAcc.accountDisplayName}
                              </td>
                              <td data-column="Add on">
                                {moment(bankAcc.createdAt).format("ll")}
                              </td>
                              <td data-column="Action">
                                <button
                                  className="btn waves-effect waves-light primary-danger table-btn "
                                  type="button"
                                  disabled={
                                    bankAcc.defaultAccount == true
                                      ? true
                                      : false
                                  }
                                  value={bankAcc.id}
                                  onClick={this.removeBankAccount}
                                  name="remove"
                                >
                                  Remove
                                </button>
                                <button
                                  className={
                                    bankAcc.defaultAccount == true
                                      ? "btn waves-effect waves-light primary-green table-btn "
                                      : "btn waves-effect waves-light primary-default  table-btn "
                                  }
                                  onClick={this.makeDefaultAccount}
                                  type="button"
                                  value={bankAcc.id}
                                  name={
                                    bankAcc.defaultAccount == true
                                      ? "Default"
                                      : "Make Default"
                                  }
                                >
                                  {bankAcc.defaultAccount == true
                                    ? "Default"
                                    : "Make Default"}
                                </button>
                              </td>
                            </tr>
                          )
                        )}
                    </tbody>
                  </table>
                  <button
                    // disabled={!isEmpty(errors)}
                    className={" waves-effect waves-light pink-btn btn-tab"}
                    type="button"
                    onClick={this.handleCancel}
                    name="cancel"
                  >
                    Close
                  </button>
                </div>
              </Modal>

              {/* Linked Bank Account Popup  Starts Here*/}

              {/* Disburse Amount Popup starts here */}

              <Modal
                isOpen={this.state.disburseAmountPopupState}
                onAfterOpen={this.openDisbursePopup}
                onRequestClose={this.closeDisbursePopup}
                style={customStylesDisburse}
                contentLabel="test"
                ariaHideApp={false}
              >
                <div className="modal-content addvehicle-content disburse-box">
                  <div className="col s12 m7">
                    <h4> Disburse Amount </h4>
                  </div>
                  <div className="col s12">
                    <div className="grey-box">
                      <div className="grey-inner">
                        <p>
                          {" "}
                          Your wallet balance of $
                          {this.state.walletBalance &&
                            this.state.walletBalance.toFixed(2)}{" "}
                          will be transferred to your bank acc, would you like
                          to proceed ?
                        </p>
                        <button
                          onClick={this.disburseAmount}
                          className="btn waves-effect waves-light primary-btn col s12 m6 offset-m3 update-profile"
                          type="submit"
                          name="action"
                        >
                          Proceed
                          <i className="material-icons">arrow_forward</i>
                        </button>

                        <button
                          onClick={this.closeDisbursePopup}
                          style={{ marginLeft: "5px" }}
                          className="btn waves-effect waves-light primary-btn col s12 m6 offset-m3 update-profile"
                          type="submit"
                          name="action"
                        >
                          Cancel
                          <i className="material-icons">arrow_forward</i>
                        </button>
                      </div>
                      <Link
                        to={"/profile"}
                        onClick={this.viewAccountsPopup}
                        className=""
                      >
                        Change Account
                      </Link>
                    </div>
                  </div>
                </div>
              </Modal>

              {/* Disburse amount popup ends here */}

              {/* Add Account Popup  Starts Here*/}
              <Modal
                isOpen={this.state.addAccountStep1}
                onAfterOpen={this.afterOpenModal}
                onRequestClose={this.closeModalResidences}
                style={customStyles}
                contentLabel="test"
                ariaHideApp={false}
              >
                <div className="row consumer-tab-info ibmfont signup-new-tabs">
                  <div className="col s12">
                    <LinkAccountStep2
                      onChangeStep2={this.onChangeStep2}
                      onChangeStep2Select={this.onChangeStep2Select}
                      handlePopupSubmit={this.handlePopupSubmit}
                      routingNumber={this.state.routingNumber}
                      accountNumber={this.state.accountNumber}
                      accountType={this.state.accountType}
                      accountHolderName={this.state.accountHolderName}
                      displayName={this.state.displayName}
                      accountHolderNameError={this.state.accountHolderNameError}
                      displayNameError={this.state.displayNameError}
                      accountNumberError={this.state.accountNumberError}
                      routingNumberError={this.state.routingNumberError}
                      accountTypeError={this.state.accountTypeError}
                      onClick={this.handleCancel}
                      addMultipleAccountState={
                        this.state.addMultipleAccountState
                      }
                    />
                    <button
                      // disabled={!isEmpty(errors)}
                      className={
                        !isEmpty(errors)
                          ? " waves-effect waves-light ltgrey-btn btn-tab"
                          : " waves-effect waves-light pink-btn btn-tab"
                      }
                      type="button"
                      onClick={this.handleCancel}
                      name="cancel"
                    >
                      Cancel
                    </button>
                    <button
                      disabled={
                        this.state.createAccEnable == false ? true : false
                      }
                      className={
                        this.state.createAccEnable == false
                          ? " waves-effect waves-light ltgrey-btn btn-tab"
                          : " waves-effect waves-light pink-btn btn-tab"
                      }
                      type="submit"
                      onClick={this.handlePopupSubmit}
                      name="back"
                    >
                      Add Account
                    </button>
                  </div>
                </div>
              </Modal>

              {/* Add Account Popup  Ends Here*/}

              {/* Link Account Popup  Starts Here*/}

              <Modal
                isOpen={this.state.linkAccountStep1}
                onAfterOpen={this.afterOpenModal}
                onRequestClose={this.closeModalResidences}
                style={customStyles}
                contentLabel="test"
                ariaHideApp={false}
              >
                <div className="row consumer-tab-info ibmfont signup-new-tabs">
                  <div className="col s12">
                    <TabContext1 value={this.state.value}>
                      <AppBar position="static">
                        <TabList1
                          onChange={this.handleChange}
                          aria-label="simple tabs example"
                        >
                          <Tab1 label="Step 1" value="1" />
                          <Tab1
                            disabled={this.state.errorCheckbox}
                            label="Step 2"
                            value="2"
                          />
                          <Tab1
                            disabled={
                              this.state.checkboxState == false ||
                              !this.state.nextButtonStepActive
                            }
                            label="Step 3"
                            value="3"
                          />
                        </TabList1>
                      </AppBar>
                      <TabPanel1 value="1">
                        <LinkAccountStep1
                          handleCheckBoxFirstStep={this.handleCheckBoxFirstStep}
                          checkboxState={this.state.checkboxState}
                          onChange={this.onChange}
                          recieveGetTranscardPaymentMethods={
                            this.props.data.recieveGetTranscardPaymentMethods
                          }
                          addMultipleAccountState={
                            this.state.addMultipleAccountState
                          }
                        />
                        <button
                          className={
                            "waves-effect waves-light pink-btn btn-tab"
                          }
                          type="button"
                          onClick={this.handleCancel}
                          name="cancel"
                        >
                          Cancel
                        </button>
                        <button
                          disabled={
                            this.state.checkboxState == false &&
                            this.state.errorCheckbox
                          }
                          className={
                            this.state.errorCheckbox
                              ? " waves-effect waves-light ltgrey-btn btn-tab"
                              : " waves-effect waves-light pink-btn btn-tab"
                          }
                          type="submit"
                          onClick={this.handleSubmitNext}
                          name="next"
                        >
                          Next
                        </button>
                      </TabPanel1>
                      <TabPanel1 value="2">
                        <LinkAccountAddress
                          onChangeAddress={this.onChangeAddress}
                          onChangeAddressSelect={this.onChangeAddressSelect}
                          handlePopupSubmit={this.handlePopupSubmit}
                          address1Popup={this.state.address1Popup}
                          address2Popup={this.state.address2Popup}
                          statePopup={this.state.statePopup}
                          statePopupName={this.state.statePopupName}
                          cityPopup={this.state.cityPopup}
                          zipPopup={this.state.zipPopup}
                          address1PopupError={this.state.address1PopupError}
                          address2PopupError={this.state.address2PopupError}
                          statePopupError={this.state.statePopupError}
                          cityPopupError={this.state.cityPopupError}
                          zipPopupError={this.state.zipPopupError}
                          addMultipleAccountState={
                            this.state.addMultipleAccountState
                          }
                          onClick={this.handleCancel}
                        />
                        <button
                          // disabled={!isEmpty(errors)}
                          className={
                            !isEmpty(errors)
                              ? " waves-effect waves-light ltgrey-btn btn-tab"
                              : " waves-effect waves-light pink-btn btn-tab"
                          }
                          type="submit"
                          onClick={this.handleCancel}
                          name="cancel"
                        >
                          Cancel
                        </button>
                        <button
                          disabled={
                            this.state.addressNextButton == false ? true : false
                          }
                          className={
                            this.state.addressNextButton == false
                              ? " waves-effect waves-light ltgrey-btn btn-tab"
                              : " waves-effect waves-light pink-btn btn-tab"
                          }
                          type="button"
                          onClick={this.handleSubmitNextAddress}
                          name="next"
                        >
                          Next
                        </button>
                      </TabPanel1>
                      <TabPanel1 value="3">
                        <LinkAccountStep2
                          onChangeStep2={this.onChangeStep2}
                          onChangeStep2Select={this.onChangeStep2Select}
                          handlePopupSubmit={this.handlePopupSubmit}
                          routingNumber={this.state.routingNumber}
                          accountNumber={this.state.accountNumber}
                          accountType={this.state.accountType}
                          accountHolderName={this.state.accountHolderName}
                          displayName={this.state.displayName}
                          accountHolderNameError={
                            this.state.accountHolderNameError
                          }
                          displayNameError={this.state.displayNameError}
                          accountNumberError={this.state.accountNumberError}
                          routingNumberError={this.state.routingNumberError}
                          accountTypeError={this.state.accountTypeError}
                          onClick={this.handleCancel}
                          addMultipleAccountState={
                            this.state.addMultipleAccountState
                          }
                        />
                        <button
                          // disabled={!isEmpty(errors)}
                          className={
                            !isEmpty(errors)
                              ? " waves-effect waves-light ltgrey-btn btn-tab"
                              : " waves-effect waves-light pink-btn btn-tab"
                          }
                          type="button"
                          onClick={this.handleCancel}
                          name="cancel"
                        >
                          Cancel
                        </button>
                        {/* <button
                    // disabled={!isEmpty(errors)}
                    className={
                      !isEmpty(errors)
                        ? " waves-effect waves-light ltgrey-btn btn-tab"
                        : " waves-effect waves-light pink-btn btn-tab"
                    }
                    type="submit"
                    onClick={this.handleSubmitBack}
                    name="back"
                  >
                    Back
                  </button> */}
                        <button
                          disabled={
                            this.state.createAccEnable == false ? true : false
                          }
                          className={
                            this.state.createAccEnable == false
                              ? " waves-effect waves-light ltgrey-btn btn-tab"
                              : " waves-effect waves-light pink-btn btn-tab"
                          }
                          type="submit"
                          onClick={this.handlePopupSubmit}
                          name="back"
                        >
                          Create Account
                        </button>
                      </TabPanel1>
                    </TabContext1>
                  </div>
                </div>
              </Modal>

              {/* Link Account Popup  Ends Here*/}

              <Modal
                isOpen={this.state.modalIsOpenResidences}
                onAfterOpen={this.afterOpenModal}
                onRequestClose={this.closeModalResidences}
                style={customStyles}
                contentLabel="test"
                ariaHideApp={false}
              >
                <form>
                  <div className="modal-content addResident-content">
                    <div className="col s12 m12 l6">
                      <div className="col s12">
                        <h4>Residences</h4>
                      </div>
                      <div className="multiinput-outer">
                        <div className="col s12 custom-select">
                          <label className="active">State*</label>
                          <select
                            name="cState"
                            value={rState}
                            onChange={this._rSelect}
                          >
                            {typeof options !== "undefined" ? options : ""}
                          </select>

                          <span
                            className={
                              errorsResidence.rStateError
                                ? "show invalid"
                                : "hide"
                            }
                          >
                            {errorsResidence.rState}
                          </span>
                        </div>

                        <div className="input-field col s12">
                          <Dropdown
                            name="cState"
                            className="browser-default"
                            options={optionsSince}
                            onChange={this._cSince1}
                            value={cDefaultSince1}
                            placeholder="Select an option*"
                          />
                          <span
                            className={
                              errorsResidence.rSinceFromError
                                ? "show invalid"
                                : "hide"
                            }
                          >
                            {errorsResidence.rSinceFrom}
                          </span>
                        </div>

                        <div className="input-field col s12">
                          <Dropdown
                            name="cState"
                            className="browser-default"
                            options={optionsSince}
                            onChange={this._cSince2}
                            value={cDefaultSince2}
                            placeholder="Select an option*"
                          />

                          <span
                            className={
                              errorsResidence.rSinceToError
                                ? "show invalid"
                                : "hide"
                            }
                          >
                            {errorsResidence.rSinceTo}
                          </span>
                        </div>
                        <div class="col s12">
                          <label>
                            <input
                              type="checkbox"
                              disabled={
                                !this.state.saveAddress
                                  ? consumerResidences.length === 1
                                  : false
                              }
                              onChange={this.AckOnchangeText}
                              name="primaryFlag"
                              value="Y"
                              checked={primaryFlag === "Y"}
                            />
                            <span>Make default address</span>
                          </label>
                        </div>
                        {/* <div className="input-field check-box-default col s12">
                    <label>
                      <input type="checkbox" name="primaryFlag" onChange={this.AckOnchangeText} value="Y" checked={primaryFlag === 'Y'} />
                      Make default address
                    </label>
                  </div> */}
                      </div>

                      <div className="input-field full-field save-button">
                        <button
                          onClick={this.handleSubmitResidences}
                          className={
                            showSaveButtonR === true
                              ? "btn waves-effect waves-light primary-btn col s12 m6 offset-m3 update-profile"
                              : "hide"
                          }
                          type="submit"
                          name="action"
                        >
                          Save
                        </button>
                        <button
                          onClick={this.handleUpdateResidences}
                          className={
                            showUpadeButtonR === true
                              ? "btn waves-effect waves-light primary-btn col s12 m6 offset-m3 update-profile"
                              : "hide"
                          }
                          type="submit"
                          name="action"
                        >
                          Update
                        </button>

                        <button
                          onClick={this.closeModalResidences}
                          style={{ marginLeft: "5px" }}
                          className="btn waves-effect waves-light primary-btn col s12 m6 offset-m3 update-profile"
                          type="submit"
                          name="action"
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </Modal>
              <div className="section-content support">
                <div className="row">
                  <div className="dashboard my-profile">
                    <div className="dashboard-tabs">
                      <BannerHead title="Profile" />
                    </div>
                  </div>
                  <div className="col s12">
                    <div className="row profile-formmain">
                      <div className="col s12 m12 l6 profileseting-formtop">
                        <form onSubmit={this.handleSubmitConsumer}>
                          <div className="row">
                            <div className="col s12">
                              <h4>Account Information</h4>
                            </div>

                            <div className="col s12">
                              <div className="row">
                                <div className="input-field col s12">
                                  <TextFieldGroup
                                    label="First Name*"
                                    field="cFirstName"
                                    value={cFirstName}
                                    error={errors.cFirstName}
                                    onChange={this.onChange}
                                  />
                                </div>

                                <div className="input-field col s12">
                                  <TextFieldGroup
                                    label="Last Name*"
                                    field="cLastName"
                                    value={cLastName}
                                    error={errors.cLastName}
                                    onChange={this.onChange}
                                  />
                                </div>
                                <div className="input-field col s12">
                                  <TextFieldGroup
                                    field="cEmail"
                                    label="Email*"
                                    value={cEmail}
                                    error={errors.cEmail}
                                    onChange={this.onChange}
                                  />
                                </div>

                                <div className="row">
                                  <div className="input-field col s12 m5 consumer-phone-code">
                                    <label className="active label-profile">
                                      Country Code
                                    </label>
                                    <Dropdown
                                      name="cState"
                                      className="browser-default"
                                      options={optionsCountry}
                                      onChange={this._cCountrySelect}
                                      value={cDefaultOptionCountry}
                                      placeholder="Select an option"
                                    />
                                  </div>
                                  <div className="input-field col s12 m7">
                                    <MaskInputNumber
                                      label="Phone Number*"
                                      field="cPhone"
                                      value={cPhone}
                                      error={errors.cPhone}
                                      onChange={this.onChange}
                                    />
                                  </div>
                                </div>

                                <div className="input-field col s12">
                                  <TextFieldGroup
                                    label="Employer*"
                                    field="cEmployer"
                                    value={cEmployer}
                                    error={errors.cEmployer}
                                    onChange={this.onChange}
                                  />
                                </div>
                              </div>
                            </div>
                            <button
                              className="btn waves-effect waves-light primary-btn col s6 offset-s3"
                              type="submit"
                              name="action"
                            >
                              Update
                              <i className="material-icons">arrow_forward</i>
                            </button>
                          </div>
                        </form>
                      </div>

                      <div className="col s12 m12 l6 profileseting-formtop profile-vehiclemiddle">
                        <h4 className="residence">Residences</h4>

                        <div>
                          <List>
                            {consumerResidences.length > 0
                              ? consumerResidences.map((value) => (
                                  <ListItem
                                    className={
                                      value.primaryFlag === "Y"
                                        ? "consumer-residence default-address"
                                        : "consumer-residence"
                                    }
                                    key={value.userResidenceId}
                                  >
                                    <ListItemText
                                      className="residence-state"
                                      primary={value.state}
                                    />
                                    <ListItemText
                                      className={
                                        value.primaryFlag === "Y"
                                          ? "residence-state default-address"
                                          : "residence-state"
                                      }
                                      primary={value.beginYear}
                                    />

                                    <ListItemText
                                      className="residence-state"
                                      primary={value.endYear}
                                    />
                                    <ListItemSecondaryAction
                                      className={
                                        value.primaryFlag === "Y"
                                          ? "default-address"
                                          : ""
                                      }
                                    >
                                      <a
                                        herf="#"
                                        className="residence-action-icons"
                                        onClick={() =>
                                          this.editResidences(
                                            value.userResidenceId,
                                            value.stateId,
                                            value.beginYear,
                                            value.endYear,
                                            value.primaryFlag
                                          )
                                        }
                                      >
                                        <Icon>edit</Icon>
                                      </a>
                                      <a
                                        herf="#"
                                        // ="residence-action-icons"
                                        className={
                                          consumerResidences.length === 1
                                            ? "residence-action-icons-disabled"
                                            : "residence-action-icons"
                                        }
                                        onClick={() =>
                                          this.deleteResidences(
                                            value.userResidenceId
                                          )
                                        }
                                      >
                                        <Icon>delete</Icon>
                                      </a>
                                    </ListItemSecondaryAction>
                                  </ListItem>
                                ))
                              : ""}
                          </List>
                          <a
                            className="cr-sgn modal-trigger residence-link"
                            onClick={this.openModalResidences}
                          >
                            Add Additional Residence
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div>
                  <ChangePassword />

                  <Vehicles />
                </div>

                <div className="col s12 ">
                  <div className="divider hdr-bdr " />
                </div>
                <div className="col s12 ">
                  <div className="row">
                    <div className="col s12  my-vehicles">
                      <h4>User Documents</h4>
                      <div className="document-body">
                        <div
                          className={
                            agreementLetterPath === "" ? "hide" : "show col s12"
                          }
                        >
                          <div className="col s12">
                            <Tooltip
                              id="tooltip-icon"
                              title="Click here to view document"
                            >
                              <a
                                className="cr-sgn modal-trigger"
                                target="_blank"
                                href={agreementLetterPath}
                              >
                                Service Agreement
                              </a>
                            </Tooltip>
                          </div>
                        </div>

                        <div
                          className={
                            letterOfAgencyPath === "" ? "hide" : "show col s12"
                          }
                        >
                          <div className="col s12">
                            <Tooltip
                              id="tooltip-icon"
                              title="Click here to view document"
                            >
                              <a
                                className="cr-sgn modal-trigger"
                                target="_blank"
                                href={letterOfAgencyPath}
                              >
                                {" "}
                                Revocable Letter Of Agency
                              </a>
                            </Tooltip>
                          </div>
                        </div>
                      </div>
                      <div
                        className={
                          privacyPolicyPath !== "" &&
                          agreementLetterPath !== "" &&
                          letterOfAgencyPath !== ""
                            ? "hide"
                            : "show col s12"
                        }
                      >
                        No Document Found
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row terms-profile">
                  <div className="col s12">
                    <div className="row">
                      <div className="col s12  my-vehicles">
                        <h4>Signature</h4>
                        <CustomSignature
                          defaultValue={signatureDefaultValue}
                          fontFamily={signatureFontFamily}
                          signBack={this.closeModal}
                          finalSubmitData={this.finalSubmit}
                          loader={false}
                          hide={false}
                          openModalSignature={this.state.modalIsOpen}
                        />
                        <div className="signaturte-uploadfile">
                          {" "}
                          {/* // className="signaturte"{" "} */}
                          {file ? <img src={file} alt="" /> : null}
                        </div>
                        <div className="col s12" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </span>
          </TabPanel>
          <TabPanel>
            <ToastContainer
              position="top-right"
              autoClose={5000}
              hideProgressBar={false}
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
            />
            {/* Disburse Amount Popup starts here */}

            <Modal
              isOpen={this.state.disburseAmountPopupState}
              onAfterOpen={this.openDisbursePopup}
              onRequestClose={this.closeDisbursePopup}
              style={customStylesDisburse}
              contentLabel="test"
              ariaHideApp={false}
            >
              <div className="modal-content addvehicle-content disburse-box">
                <div class="pop-header">Transfer Funds</div>
                <div className="found-popup-body">
                  <p className="top-p">
                    Select account to transfer your funds to:
                  </p>
                  <div className="acc-holder-name">
                    {this.state.transcardAccountState
                      ? this.props.receiveGetAddedBankAccountsForUser &&
                        this.props.receiveGetAddedBankAccountsForUser.code ==
                          "200" &&
                        this.props.receiveGetAddedBankAccountsForUser.result.map(
                          (bankAcc) => bankAcc.accountDisplayName
                        )
                      : this.props.receiveGetAddedCardsForUser &&
                        this.props.receiveGetAddedCardsForUser.code == "200" &&
                        this.props.receiveGetAddedCardsForUser.result.map(
                          (card) => card.cardNickName
                        )}
                  </div>

                  <div className="funds-list-outer">
                    <p className="w-acc-link" />
                    <p className="p-sub">
                      This could take up to 2 business days to transfer
                    </p>
                    <div className="fund-list">
                      <div className="fund-list-count">
                        <p>Settlement Amount:</p>
                        <span className="fund-cost">
                          $
                          {this.props.receiveShowNetAmountToUser.data &&
                            this.props.receiveShowNetAmountToUser.data.result.totalAmount.toFixed(
                              2
                            )}
                        </span>
                      </div>
                      <div className="fund-list-count">
                        {this.state.transcardAccountState == true ? (
                          <p>ACH transfer fee (3%):</p>
                        ) : (
                          <p>Instant fee (5%):</p>
                        )}

                        <span className="fund-cost">
                          ($
                          {this.props.receiveShowNetAmountToUser.data &&
                            this.props.receiveShowNetAmountToUser.data.result.transferFee.toFixed(
                              2
                            )}
                          )
                        </span>
                      </div>
                      <div className="fund-list-count">
                        <p>Final Transfer Amount: </p>
                        <span className="fund-cost-total">
                          $
                          {this.props.receiveShowNetAmountToUser.data &&
                            this.props.receiveShowNetAmountToUser.data.result.finalAmountToBeCollected.toFixed(
                              2
                            )}
                        </span>
                      </div>
                    </div>
                    <p className="btm-p">
                      After clicking Transfer Funds, this process is final and
                      cannot be undone.
                    </p>
                    <div className="popup-footer">
                      <button
                        className="btn btn-footer-1"
                        type="submit"
                        name="action"
                        onClick={this.closeDisbursePopup}
                      >
                        Cancel
                      </button>
                      <button
                        className="btn btn-footer-2"
                        type="submit"
                        name="action"
                        onClick={this.disburseAmount}
                      >
                        Transfer Funds
                      </button>
                    </div>
                  </div>
                </div>

                {/* <div className="col s12">
              <div className="grey-box">
                <div className="grey-inner">
                  <p> Your wallet balance of ${this.state.walletBalance && this.state.walletBalance.toFixed(2)} will be transferred to your bank acc, would you like to proceed ?</p>
                  <button
                    onClick={this.disburseAmount}
                    className="btn waves-effect waves-light primary-btn col s12 m6 offset-m3 update-profile"
                    type="submit"
                    name="action"
                  >
                    Proceed
                    <i className="material-icons">arrow_forward</i>
                  </button>

                  <button
                    onClick={this.closeDisbursePopup}
                    style={{ marginLeft: "5px" }}
                    className="btn waves-effect waves-light primary-btn col s12 m6 offset-m3 update-profile"
                    type="submit"
                    name="action"
                  >
                    Cancel
                    <i className="material-icons">arrow_forward</i>
                  </button>
                  
                </div>
                <Link to={'/profile'} onClick={this.viewAccountsPopup}  className="">Change Account</Link>
              </div>
            </div> */}
              </div>
            </Modal>

            {/* Disburse amount popup ends here */}

            {/* Disburse Amount Popup starts here */}

            <Modal
              isOpen={this.state.disburseCardPopupState}
              onAfterOpen={this.openDisbursePopup}
              onRequestClose={this.closeDisbursePopup}
              style={customStylesDisburse}
              contentLabel="test"
              ariaHideApp={false}
            >
              <div className="modal-content addvehicle-content disburse-box">
                <div class="pop-header">Transfer Funds</div>
                <div className="found-popup-body">
                  <p className="top-p">
                    Select account to transfer your funds to:
                  </p>
                  <div className="acc-holder-name">
                    {this.props.receiveGetAddedCardsForUser &&
                      this.props.receiveGetAddedCardsForUser.code == "200" &&
                      this.props.receiveGetAddedCardsForUser.result.map(
                        (card) => card.cardNickName
                      )}
                  </div>

                  <div className="funds-list-outer">
                    <p className="w-acc-link" />
                    <p className="p-sub">
                      This could take up to 2 business days to transfer
                    </p>
                    <div className="fund-list">
                      <div className="fund-list-count">
                        <p>Settlement Amount:</p>
                        <span className="fund-cost">
                          $
                          {this.props.receiveShowNetAmountToUser.data &&
                            this.props.receiveShowNetAmountToUser.data.result.totalAmount.toFixed(
                              2
                            )}
                        </span>
                      </div>
                      <div className="fund-list-count">
                        <p>ACH transfer fee (3%):</p>
                        <span className="fund-cost">
                          ($
                          {this.props.receiveShowNetAmountToUser.data &&
                            this.props.receiveShowNetAmountToUser.data.result.transferFee.toFixed(
                              2
                            )}
                          )
                        </span>
                      </div>
                      <div className="fund-list-count">
                        <p>Final Transfer Amount: </p>
                        <span className="fund-cost-total">
                          $
                          {this.props.receiveShowNetAmountToUser.data &&
                            this.props.receiveShowNetAmountToUser.data.result.finalAmountToBeCollected.toFixed(
                              2
                            )}
                        </span>
                      </div>
                    </div>
                    <p className="btm-p">
                      After clicking Transfer Funds, this process is final and
                      cannot be undone.
                    </p>
                    <div className="popup-footer">
                      <button
                        className="btn btn-footer-1"
                        type="submit"
                        name="action"
                        onClick={this.closeDisbursePopup}
                      >
                        Cancel
                      </button>
                      <button
                        className="btn btn-footer-2"
                        type="submit"
                        name="action"
                        onClick={this.disburseAmount}
                      >
                        Transfer Funds
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </Modal>

            {/* Disburse amount popup ends here */}

            {/* Save Card details Popup  Starts Here*/}

            <Modal
              isOpen={this.state.instantTransferPopupState}
              onAfterOpen={this.afterOpenModal}
              onRequestClose={this.closeInstantPopup}
              style={customStylesCardDetails}
              contentLabel="test"
              ariaHideApp={false}
            >
              <div className="pop-header">Save Card Details</div>
              <div className="row consumer-tab-info ibmfont signup-new-tabs card-change">
                <div className="col s12">
                  <CardInputField
                    divClassName="input-field col s4"
                    field="cardFirstName"
                    label="First Name *"
                    // placeholder="Name on Card"
                    value={cardFirstName}
                    error={cardErrors.cardFirstName}
                    onChange={this.onChangeCarad}
                  />
                  <CardInputField
                    divClassName="input-field col s4"
                    field="cardLastName"
                    label="Last Name  *"
                    // placeholder="Name on Card"
                    value={cardLastName}
                    error={cardErrors.cardLastName}
                    onChange={this.onChangeCarad}
                  />
                  <CardInputField
                    divClassName="input-field col s4"
                    field="cardNickName"
                    label="Nick Name *"
                    // placeholder="Name on Card"
                    value={cardNickName}
                    error={cardErrors.cardNickName}
                    onChange={this.onChangeCarad}
                  />
                  <CardInputMaskinking
                    divClassName="input-field col s12 pb-20 mb-0"
                    field="cardNumber"
                    label="Card Number *"
                    placeholder="Card Number"
                    value={cardNumber}
                    error={cardErrors.cardNumber}
                    onChange={this.onChangeCarad}
                    mask="9999 9999 9999 9999"
                  />
                  <CardInputMaskinking
                    divClassName="input-field col s4"
                    field="cardMonth"
                    label="Month *"
                    placeholder="Month"
                    value={cardMonth}
                    error={cardErrors.cardMonth}
                    onChange={this.onChangeCarad}
                    mask="99"
                  />
                  <CardInputMaskinking
                    divClassName="input-field col s4 checkoutyear-input mb-0"
                    field="cardYear"
                    label="Year *"
                    placeholder="Year"
                    value={cardYear}
                    error={cardErrors.cardYear}
                    onChange={this.onChangeCarad}
                    mask="99"
                  />
                  <CardInputMaskinking
                    divClassName="input-field col s4"
                    field="cardCvv"
                    label="CVV *"
                    placeholder="CVV"
                    value={cardCvv}
                    error={cardErrors.cardCvv}
                    onChange={this.onChangeCarad}
                    mask="9999"
                  />
                  <div className="w-dflex col s12">
                    <button
                      onClick={this.handleSaveCard}
                      disabled={
                        this.state.cardErrorsState.cardNickName == "" &&
                        this.state.cardErrorsState.cardNickNameError == false &&
                        this.state.cardErrorsState.cardLastName == "" &&
                        this.state.cardErrorsState.cardLastNameError == false &&
                        this.state.cardErrorsState.cardFirstName == "" &&
                        this.state.cardErrorsState.cardFirstNameError ==
                          false &&
                        this.state.cardErrorsState.cardFirstName == "" &&
                        this.state.cardErrorsState.cardFirstNameError ==
                          false &&
                        this.state.cardErrorsState.cardCvv == "" &&
                        this.state.cardErrorsState.cardCvvError == "" &&
                        this.state.cardErrorsState.cardMonth == false &&
                        this.state.cardErrorsState.cardMonthError == "" &&
                        this.state.cardErrorsState.cardNumber == false &&
                        this.state.cardErrorsState.cardNumberError == "" &&
                        this.state.cardErrorsState.cardYear == false &&
                        this.state.cardErrorsState.cardYearError == ""
                          ? false
                          : true
                      }
                      className="btn btn-primary"
                      type="submit"
                      name="action"
                    >
                      Save
                    </button>
                  </div>
                </div>
              </div>
            </Modal>

            {/* Save Card details  Ends Here*/}
            {/* Link New Account Popup  Starts Here*/}

            <Modal
              isOpen={this.state.bankAccountConfirmationPopup}
              onAfterOpen={this.afterOpenModal}
              onRequestClose={this.closeModalResidences}
              style={customStylesConfirmationPopup}
              contentLabel="test"
              ariaHideApp={false}
            >
              <div className="pop-header">Please Select Bank Account</div>
              <div className="row consumer-tab-info ibmfont signup-new-tabs">
                <div className="col s12 pt-5">
                  {this.state.noAccountLinked == false
                    ? "You can select from your previously linked Bank accounts:"
                    : "Please add new account:-"}
                  <div className=" full-field padding-field">
                    <p className="radio-outer confirm-radio-popup">
                      {this.props.receiveGetAllBankAccountsForUser &&
                        this.props.receiveGetAllBankAccountsForUser.data &&
                        this.props.receiveGetAllBankAccountsForUser.data
                          .result &&
                        this.props.receiveGetAllBankAccountsForUser.data.result.map(
                          (displayName) => (
                            <label>
                              <input
                                className="with-gap"
                                name="accountName"
                                onChange={this.accountNameChange}
                                checked={
                                  this.state.radioAccountValue == displayName.id
                                }
                                value={displayName.id}
                                type="checkbox"
                                
                              />
                              <span>{displayName.accountDisplayName}</span>
                            </label>
                          )
                        )}
                    </p>
                  </div>
                  {this.state.noAccountLinked == false ? (
                    <button
                      disabled={
                        !this.state.radioAddedAccountChecked === true
                          ? true
                          : false
                      }
                      className={"waves-effect waves-light pink-btn btn-tab"}
                      type="submit"
                      onClick={this.handleAlreadyAddedAccount}
                      name="back"
                    >
                      Continue
                    </button>
                  ) : (
                    ""
                  )}

                  <button
                    disabled={
                      this.state.radioAddedAccountChecked === true
                        ? true
                        : false
                    }
                    className={"waves-effect waves-light pink-btn btn-tab"}
                    type="submit"
                    onClick={this.handleAddNewAccount}
                    name="back"
                    value="addNewAccount"
                  >
                    Add New Account
                  </button>
                </div>
              </div>
            </Modal>

            {/* Link New Account Popup  Ends Here*/}
            {/* Link New Card Popup  Starts Here*/}

            <Modal
              isOpen={this.state.bankCardConfirmationPopup}
              onAfterOpen={this.afterOpenModal}
              onRequestClose={this.closeModalResidences}
              style={customStylesConfirmationPopup}
              contentLabel="test"
              ariaHideApp={false}
            >
              <div className="pop-header">Please Select Card</div>
              <div className="row consumer-tab-info ibmfont signup-new-tabs">
                <div className="col s12 pt-5">
                  {this.state.noCardLinked == false
                    ? "You can select from your previously linked cards:"
                    : "Please add new card:-"}
                  <div className=" full-field padding-field">
                    <p className="radio-outer confirm-radio-popup">
                      {this.props.receiveGetAllAddedCardsForUser &&
                        this.props.receiveGetAllAddedCardsForUser.data &&
                        this.props.receiveGetAllAddedCardsForUser.data.result &&
                        this.props.receiveGetAllAddedCardsForUser.data.result.map(
                          (displayName) => (
                            <label>
                              <input
                                className="with-gap"
                                name="accountName"
                                onChange={this.cardNameChange}
                                checked={
                                  this.state.radioCardValue == displayName.id
                                }
                                value={displayName.id}
                                type="checkbox"
                              />
                              <span>{displayName.cardNickName}</span>
                            </label>
                          )
                        )}
                    </p>
                  </div>
                  {this.state.noCardLinked == false ? (
                    <button
                      disabled={
                        !this.state.radioAddedCardChecked === true
                          ? true
                          : false
                      }
                      className={"waves-effect waves-light pink-btn btn-tab"}
                      type="submit"
                      onClick={this.handleAlreadyAddedCard}
                      name="back"
                    >
                      Continue
                    </button>
                  ) : (
                    ""
                  )}
                  <button
                    disabled={
                      this.state.radioAddedCardChecked === true ? true : false
                    }
                    className={"waves-effect waves-light pink-btn btn-tab"}
                    type="submit"
                    onClick={this.handleAddNewCard}
                    name="back"
                    value="addNewCard"
                  >
                    Add New Card
                  </button>
                </div>
              </div>
            </Modal>

            {/* Link New Card Popup  Ends Here*/}
            {/* Link Account Popup  Starts Here*/}

            <Modal
              isOpen={this.state.nextButtonStepActive}
              onAfterOpen={this.afterOpenModal}
              onRequestClose={this.closeModalResidences}
              style={customStyles}
              contentLabel="test"
              ariaHideApp={false}
            >
              <div className="pop-header">Link Account</div>
              <div className="row consumer-tab-info ibmfont signup-new-tabs">
                <div className="col s12">
                  <TabContext1 value={this.state.value}>
                    <TabPanel1 value="3">
                      <LinkAccountStep2
                        onChangeStep2={this.onChangeStep2}
                        onChangeStep2Select={this.onChangeStep2Select}
                        handlePopupSubmit={this.handlePopupSubmit}
                        routingNumber={this.state.routingNumber}
                        accountNumber={this.state.accountNumber}
                        accountType={this.state.accountType}
                        accountHolderName={this.state.accountHolderName}
                        displayName={this.state.displayName}
                        accountHolderNameError={
                          this.state.accountHolderNameError
                        }
                        displayNameError={this.state.displayNameError}
                        accountNumberError={this.state.accountNumberError}
                        routingNumberError={this.state.routingNumberError}
                        accountTypeError={this.state.accountTypeError}
                        addMultipleAccountState={
                          this.state.addMultipleAccountState
                        }
                        onClick={this.handleCancel}
                      />
                      <button
                        // disabled={!isEmpty(errors)}
                        className={
                          !isEmpty(errors)
                            ? " waves-effect waves-light ltgrey-btn btn-tab"
                            : " waves-effect waves-light pink-btn btn-tab"
                        }
                        type="submit"
                        onClick={this.handleCancel}
                        name="cancel"
                      >
                        Cancel
                      </button>
                      <button
                        disabled={
                          this.state.createAccEnable == false ? true : false
                        }
                        className={
                          this.state.createAccEnable == true
                            ? " waves-effect waves-light ltgrey-btn btn-tab"
                            : " waves-effect waves-light pink-btn btn-tab"
                        }
                        type="submit"
                        onClick={this.handlePopupSubmit}
                        name="back"
                      >
                        Create Account
                      </button>
                    </TabPanel1>
                  </TabContext1>
                </div>
              </div>
            </Modal>

            {/* Link Account Popup  Ends Here*/}

            {/* Account Type Popup starts here */}

            <Modal
              isOpen={this.state.accountTypePopupState}
              onAfterOpen={this.openAccountTypePopup}
              onRequestClose={this.closeAccountTypePopup}
              style={customStylesTransferType}
              contentLabel="test"
              ariaHideApp={false}
            >
              <div className="pop-header">Transfer Type</div>
              <div className="modal-content addvehicle-content disburse-box">
                <div className="radio radio-new">
                  <form
                    className="p-30 p-form"
                    onSubmit={this.handleSubmitTransferType}
                  >
                    <label className="mb-3">
                      <input
                        type="radio"
                        name="radio"
                        value="ach"
                        onChange={this.onTransferCheck}
                        checked={this.state.achState}
                      />
                      <span>ACH</span>
                    </label>
                    <label className="mb-3">
                      <input
                        type="radio"
                        name="radio"
                        onChange={this.onTransferCheck}
                        value="instant"
                        checked={this.state.instantTransferState}
                      />
                      <span>Instant Transfer</span>
                    </label>
                    {this.state.instantTransferState == true ||
                    this.state.achState == true ? (
                      <p>
                        {this.state.achState == true
                          ? "You will be charged 3% of the amount as transaction fee"
                          : "You will be charged 5% of the amount as transaction fee"}
                      </p>
                    ) : (
                      ""
                    )}

                    <div className="w-dflex mt-3">
                      <button
                        disabled={
                          this.state.instantTransferState === false &&
                          this.state.achState === false
                        }
                        type="submit"
                        name="next"
                        className="btn btn-primary"
                      >
                        Next
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </Modal>

            {/* Account Type popup ends here */}

            {/* Edit Accout Popup Starts Here */}

            <Modal
              isOpen={this.state.openEditModel}
              onAfterOpen={this.afterOpenModal}
              onRequestClose={this.closeModalResidences}
              style={customEditStyles}
              contentLabel="test"
              ariaHideApp={false}
            >
              <div className="pop-header">Edit Account</div>
              <div className="found-popup-body">
                <p className="edit-popup-pb">
                  {this.props.receiveGetAddedBankAccountsForUser &&
                  this.props.receiveGetAddedBankAccountsForUser.code == "200" &&
                  this.props.receiveGetAddedBankAccountsForUser.result[0]
                    .accountType == "1"
                    ? "Checking Account"
                    : "Savings Account"}{" "}
                </p>
                <span className="nick-name-l">Account Nickname</span>
                <div className="e-holder-name">
                  {this.props.receiveGetAddedBankAccountsForUser &&
                    this.props.receiveGetAddedBankAccountsForUser.code ==
                      "200" &&
                    this.props.receiveGetAddedBankAccountsForUser.result.map(
                      (bankAcc) => (
                        <input
                          name="bankName"
                          value={this.state.bankName}
                          onChange={this.onChangeEditAccount}
                        />
                      )
                    )}
                </div>
                {this.state.errorbankName == true ? (
                  <div
                    className="error-class"
                    style={{ fontSize: 12, color: "red" }}
                  >
                    This field can't be blank.
                  </div>
                ) : (
                  ""
                )}
                <div className="d-option">
                  {this.state.showDeleteConfirmation == false ? (
                    <div
                      onClick={this.handleShowDeleteConfirmation}
                      style={{
                        cursor: "pointer",
                        color: "#1f202e",
                        opacity: ".3",
                        textDecoration: "underline",
                      }}
                    >
                      Delete This Account
                    </div>
                  ) : (
                    ""
                  )}
                </div>
                {this.state.showDeleteConfirmation ? (
                  <div className="delet-option-btn">
                    <p>Are you sure you want to delete this account?</p>
                    <div className="btn-outer-delet">
                      <button
                        className="btn btn-dlt"
                        onClick={this.removeBankAccount}
                        value={
                          this.props.receiveGetAddedBankAccountsForUser &&
                          this.props.receiveGetAddedBankAccountsForUser
                            .result &&
                          this.props.receiveGetAddedBankAccountsForUser
                            .result[0].id
                        }
                        type="submit"
                        name="action"
                      >
                        Delete Account
                      </button>
                      <button
                        onClick={this.handleShowDeleteConfirmation}
                        className="btn btn-clc"
                        type="submit"
                        name="action"
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                ) : (
                  ""
                )}

                <div className="popup-footer edit-poup-footer">
                  <button
                    className="btn btn-footer-1"
                    type="submit"
                    onClick={this.cancelEditModel}
                    name="action"
                  >
                    Cancel
                  </button>
                  <button
                    className="btn btn-footer-2"
                    type="submit"
                    disabled={this.state.updateBankButton == false}
                    onClick={this.changeBankNickName}
                    name="action"
                  >
                    Save Changes
                  </button>
                </div>
              </div>
            </Modal>

            {/* Edit Account Popup Ends Here */}

            {/* Edit Card Popup Starts Here */}

            <Modal
              isOpen={this.state.openEditCardModel}
              onAfterOpen={this.afterOpenModal}
              onRequestClose={this.closeModalResidences}
              style={customEditStyles}
              contentLabel="test"
              ariaHideApp={false}
            >
              <div className="pop-header">Edit Card</div>
              <div className="found-popup-body">
                <p className="edit-popup-pb">
                  {this.props.receiveGetAddedCardsForUser &&
                  this.props.receiveGetAddedCardsForUser.code == "200"
                    ? "Card Details"
                    : "Card Details"}{" "}
                </p>
                <span className="nick-name-l">Card Nickname</span>
                <div className="e-holder-name">
                  {this.props.receiveGetAddedCardsForUser &&
                    this.props.receiveGetAddedCardsForUser.code == "200" &&
                    this.props.receiveGetAddedCardsForUser.result.map(
                      (card) => (
                        <input
                          name="bankName"
                          value={this.state.cardNickName}
                          onChange={this.onChangeEditCard}
                        />
                      )
                    )}
                </div>
                {this.state.errorCardName == true ? (
                  <div
                    className="error-class"
                    style={{ fontSize: 12, color: "red" }}
                  >
                    This field can't be blank.
                  </div>
                ) : (
                  ""
                )}
                <div className="d-option">
                  {this.state.showDeleteConfirmation == false ? (
                    <div
                      onClick={this.handleShowDeleteConfirmation}
                      style={{
                        cursor: "pointer",
                        color: "#1f202e",
                        opacity: ".3",
                        textDecoration: "underline",
                      }}
                    >
                      Delete This Account
                    </div>
                  ) : (
                    ""
                  )}
                </div>
                {this.state.showDeleteConfirmation ? (
                  <div className="delet-option-btn">
                    <p>Are you sure you want to delete this card?</p>
                    <div className="btn-outer-delet">
                      <button
                        className="btn btn-dlt"
                        onClick={this.removeBankCard}
                        value={
                          this.props.receiveGetAddedCardsForUser &&
                          this.props.receiveGetAddedCardsForUser.result &&
                          this.props.receiveGetAddedCardsForUser.result[0].id
                        }
                        type="submit"
                        name="action"
                      >
                        Delete card
                      </button>
                      <button
                        onClick={this.handleShowDeleteConfirmation}
                        className="btn btn-clc"
                        type="submit"
                        name="action"
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                ) : (
                  ""
                )}

                <div className="popup-footer edit-poup-footer">
                  <button
                    className="btn btn-footer-1"
                    type="submit"
                    onClick={this.cancelEditModel}
                    name="action"
                  >
                    Cancel
                  </button>
                  <button
                    className="btn btn-footer-2"
                    type="submit"
                    disabled={this.state.updateCardButton == false}
                    onClick={this.changeCardNickName}
                    name="action"
                  >
                    Save Changes
                  </button>
                </div>
              </div>
            </Modal>

            {/* Edit Card Popup Ends Here */}

            {/* Address Popup  Starts Here*/}

            <Modal
              isOpen={this.state.linkAccountStep1}
              onAfterOpen={this.afterOpenModal}
              onRequestClose={this.closeModalResidences}
              style={customStyles}
              contentLabel="test"
              ariaHideApp={false}
            >
              <div className="pop-header">Address</div>
              <div className="row consumer-tab-info ibmfont signup-new-tabs">
                <div className="col s12">
                  <TabContext1 value={this.state.value}>
                    <TabPanel1 value="1">
                      <LinkAccountAddress
                        onChangeAddress={this.onChangeAddress}
                        onChangeAddressSelect={this.onChangeAddressSelect}
                        handlePopupSubmit={this.handlePopupSubmit}
                        address1Popup={this.state.address1Popup}
                        address2Popup={this.state.address2Popup}
                        statePopup={this.state.statePopup}
                        statePopupName={this.state.statePopupName}
                        cityPopup={this.state.cityPopup}
                        zipPopup={this.state.zipPopup}
                        address1PopupError={this.state.address1PopupError}
                        address2PopupError={this.state.address2PopupError}
                        statePopupError={this.state.statePopupError}
                        cityPopupError={this.state.cityPopupError}
                        zipPopupError={this.state.zipPopupError}
                        addMultipleAccountState={
                          this.state.addMultipleAccountState
                        }
                        onClick={this.handleCancel}
                      />
                      <button
                        // disabled={!isEmpty(errors)}
                        className={
                          !isEmpty(errors)
                            ? " waves-effect waves-light ltgrey-btn btn-tab"
                            : " waves-effect waves-light pink-btn btn-tab"
                        }
                        type="submit"
                        onClick={this.handleCancel}
                        name="cancel"
                      >
                        Cancel
                      </button>
                      <button
                        disabled={
                          this.state.addressNextButton == false ? true : false
                        }
                        className={
                          this.state.addressNextButton == true
                            ? " waves-effect waves-light ltgrey-btn btn-tab"
                            : " waves-effect waves-light pink-btn btn-tab"
                        }
                        type="submit"
                        onClick={this.handleSubmitNextAddress}
                        name="next"
                      >
                        Next
                      </button>
                    </TabPanel1>
                  </TabContext1>
                </div>
              </div>
            </Modal>

            {/* Address Popup  Ends Here*/}

            {/*Card Address Popup  Starts Here*/}

            <Modal
              isOpen={this.state.linkCardAccountStep1}
              onAfterOpen={this.afterOpenModal}
              onRequestClose={this.closeModalResidences}
              style={customStyles}
              contentLabel="test"
              ariaHideApp={false}
            >
              <div className="pop-header">Card Address</div>
              <div className="row consumer-tab-info ibmfont signup-new-tabs">
                <div className="col s12">
                  <TabContext1 value={this.state.cardValue}>
                    <TabPanel1 value="1">
                      <LinkCardAccountAddress
                        onChangeCardAddress={this.onChangeCardAddress}
                        onChangeCardAddressSelect={
                          this.onChangeCardAddressSelect
                        }
                        handlePopupSubmit={this.handlePopupSubmit}
                        address1CardPopup={this.state.address1CardPopup}
                        address2CardPopup={this.state.address2CardPopup}
                        cityCardPopup={this.state.cityCardPopup}
                        zipCardPopup={this.state.zipCardPopup}
                        address1CardPopupError={
                          this.state.address1CardPopupError
                        }
                        address2CardPopupError={
                          this.state.address2CardPopupError
                        }
                        stateCardPopupName={this.state.stateCardPopupName}
                        stateCardPopup={this.state.stateCardPopup}
                        cityCardPopupError={this.state.cityCardPopupError}
                        zipCardPopupError={this.state.zipCardPopupError}
                        addMultipleAccountState={
                          this.state.addMultipleAccountState
                        }
                        onClick={this.handleCancel}
                      />
                      <button
                        // disabled={!isEmpty(errors)}
                        className={
                          !isEmpty(errors)
                            ? " waves-effect waves-light ltgrey-btn btn-tab"
                            : " waves-effect waves-light pink-btn btn-tab"
                        }
                        type="submit"
                        onClick={this.handleCancel}
                        name="cancel"
                      >
                        Cancel
                      </button>
                      <button
                        disabled={
                          this.state.addressCardNextButton == false
                            ? true
                            : false
                        }
                        className={
                          this.state.addressCardNextButton == true
                            ? " waves-effect waves-light ltgrey-btn btn-tab"
                            : " waves-effect waves-light pink-btn btn-tab"
                        }
                        type="submit"
                        onClick={this.handleSubmitNextCardAddress}
                        name="next"
                      >
                        Next
                      </button>
                    </TabPanel1>
                  </TabContext1>
                </div>
              </div>
            </Modal>

            {/*Card Address Popup  Ends Here*/}

            {/* Add Card Popup  Starts Here*/}
            <Modal
              isOpen={this.state.nextCardButtonStepActive}
              onAfterOpen={this.afterOpenModal}
              onRequestClose={this.closeModalResidences}
              style={customStyles}
              contentLabel="test"
              ariaHideApp={false}
            >
              <div className="pop-header">Link Card</div>
              <div className="row consumer-tab-info ibmfont signup-new-tabs">
                <div className="col s12">
                  <TabContext1 value={this.state.cardValue}>
                    <TabPanel1 value="3">
                      <div className="row consumer-tab-info ibmfont signup-new-tabs card-change">
                        <div className="col s12">
                          <CardInputField
                            divClassName="input-field col s6"
                            field="cardFirstName"
                            label="First Name *"
                            // placeholder="Name on Card"
                            value={cardFirstName}
                            error={cardErrors.cardFirstName}
                            onChange={this.onChangeCarad}
                          />
                          <CardInputField
                            divClassName="input-field col s6"
                            field="cardLastName"
                            label="Last Name  *"
                            // placeholder="Name on Card"
                            value={cardLastName}
                            error={cardErrors.cardLastName}
                            onChange={this.onChangeCarad}
                          />
                          <CardInputField
                            divClassName="input-field col s6"
                            field="cardNickName"
                            label="Nick Name *"
                            // placeholder="Name on Card"
                            value={cardNickName}
                            error={cardErrors.cardNickName}
                            onChange={this.onChangeCarad}
                          />
                          <CardInputMaskinking
                            divClassName="input-field col s8"
                            field="cardNumber"
                            label="Card Number *"
                            placeholder="Card Number"
                            value={cardNumber}
                            error={cardErrors.cardNumber}
                            onChange={this.onChangeCarad}
                            mask="9999 9999 9999 9999"
                          />
                          <CardInputMaskinking
                            divClassName="input-field col s4"
                            field="cardCvv"
                            label="CVV *"
                            placeholder="CVV"
                            value={cardCvv}
                            error={cardErrors.cardCvv}
                            onChange={this.onChangeCarad}
                            mask="9999"
                          />
                          <CardInputMaskinking
                            divClassName="input-field col s4"
                            field="cardMonth"
                            label="Month *"
                            placeholder="Month"
                            value={cardMonth}
                            error={cardErrors.cardMonth}
                            onChange={this.onChangeCarad}
                            mask="99"
                          />
                          <CardInputMaskinking
                            divClassName="input-field col s4 checkoutyear-input mb-0"
                            field="cardYear"
                            label="Year *"
                            placeholder="Year"
                            value={cardYear}
                            error={cardErrors.cardYear}
                            onChange={this.onChangeCarad}
                            mask="99"
                          />
                          <div className="w-dflex col s12"></div>
                        </div>
                      </div>
                      <button
                        // disabled={!isEmpty(errors)}
                        className={
                          !isEmpty(errors)
                            ? " waves-effect waves-light ltgrey-btn btn-tab"
                            : " waves-effect waves-light pink-btn btn-tab"
                        }
                        type="submit"
                        onClick={this.handleCancel}
                        name="cancel"
                      >
                        Cancel
                      </button>
                      <button
                        // disabled={
                        //   this.state.createAccEnable == false ? true : false
                        // }
                        disabled={
                          this.state.cardErrorsState.cardNickName == "" &&
                          this.state.cardErrorsState.cardNickNameError ==
                            false &&
                          this.state.cardErrorsState.cardLastName == "" &&
                          this.state.cardErrorsState.cardLastNameError ==
                            false &&
                          this.state.cardErrorsState.cardFirstName == "" &&
                          this.state.cardErrorsState.cardFirstNameError ==
                            false &&
                          this.state.cardErrorsState.cardFirstName == "" &&
                          this.state.cardErrorsState.cardFirstNameError ==
                            false &&
                          this.state.cardErrorsState.cardCvv == "" &&
                          this.state.cardErrorsState.cardCvvError == "" &&
                          this.state.cardErrorsState.cardMonth == false &&
                          this.state.cardErrorsState.cardMonthError == "" &&
                          this.state.cardErrorsState.cardNumber == false &&
                          this.state.cardErrorsState.cardNumberError == "" &&
                          this.state.cardErrorsState.cardYear == false &&
                          this.state.cardErrorsState.cardYearError == ""
                            ? false
                            : true
                        }
                        className={
                          this.state.createAccEnable == true
                            ? " waves-effect waves-light ltgrey-btn btn-tab"
                            : " waves-effect waves-light pink-btn btn-tab"
                        }
                        type="submit"
                        onClick={
                          this.state.cardAlreadyLinked == false
                            ? this.handleCardPopupSubmit
                            : this.handleCardPopupAlreadyLinkedSubmit
                        }
                        name="back"
                      >
                        Create Account
                      </button>
                    </TabPanel1>
                  </TabContext1>
                </div>
              </div>
            </Modal>

            {/* Add Card Popup  Ends Here*/}
            <ToastsContainer
              store={ToastsStore}
              className="toast-error-msg"
              position={ToastsContainerPosition.TOP_CENTER}
              lightBackground
            />
            {loader1}
            <div
              className="wallet-1 wallet-1-top {
    display: flex;
}"
            >
              <div className="top-left-head">
                <h3 className="w-h3">Available Funds</h3>
                <div className="w-dflex">
                  <div className="w-link-acc">
                    <div className="w-link-count">
                      ${walletBalance ? walletBalance.toFixed(2) : 0.0}
                    </div>
                    <div className="w-lock">
                      <img
                        src={
                          this.state.transcardAccountState == false &&
                          this.state.transcardCardState == false
                            ? lockImage
                            : ""
                        }
                      />
                    </div>
                    <button
                      className={
                        this.state.transcardAccountState == false
                          ? "btn btn-primary link-transfer"
                          : "btn btn-primary link-transfer"
                      }
                      value="addNewLinkAccount"
                      onClick={
                        (this.state.transcardAccountState == true &&
                          this.state.hasAnyActiveAccount == true &&
                          this.state.noAccountLinked == false) ||
                        (this.state.transcardCardState == true &&
                          this.state.hasAnyActiveCard == true &&
                          this.state.noCardLinked == false)
                          ? this.disburseAmountPopup
                          : this.state.AddNewBankAccountState == true &&
                            this.state.noAccountLinked == false &&
                            this.state.userHasNoAccounts == false
                          ? this.accountTypePopup
                          : this.accountTypePopup
                      }
                      disabled={walletBalance === 0}
                      name={
                        this.state.transcardAccountState == true
                          ? "transferFunds"
                          : "linkToTransfer"
                      }
                    >
                      {(this.state.transcardAccountState == true &&
                        this.state.hasAnyActiveAccount == true &&
                        this.state.noAccountLinked == false) ||
                      (this.state.transcardCardState == true &&
                        this.state.hasAnyActiveCard == true &&
                        this.state.noCardLinked == false)
                        ? "Transfer Funds"
                        : (this.state.AddNewBankAccountState == true &&
                            this.state.noAccountLinked == false &&
                            this.state.userHasNoAccounts == false) ||
                          (this.state.AddNewCardState == true &&
                            this.state.noCardLinked == false &&
                            this.state.userHasNoCards == false)
                        ? "Add Payment Method"
                        : "Link Account to Transfer Funds"}
                    </button>
                  </div>
                  {walletBalance != 0 &&
                  this.state.transcardAccountState == false &&
                  this.state.transcardCardState == false ? (
                    <div className="w-lable">
                      To transfer funds, we first need to securely link to your
                      account.
                      <span className="qus-icon">?</span>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </div>
              {this.state.transcardAccountState == true ? (
                <div className="top-right-head">
                  {this.props.receiveGetAddedBankAccountsForUser &&
                  this.props.receiveGetAddedBankAccountsForUser.code ==
                    "200" ? (
                    <div className="w-link-btn bdr-btm-1">
                      {" "}
                      <h3>Linked Account</h3>
                    </div>
                  ) : (
                    ""
                  )}
                  {/* <button className="btn btn-link-acc">
                         Add Another Account
                         </button> */}

                  {this.props.receiveGetAddedBankAccountsForUser &&
                    this.props.receiveGetAddedBankAccountsForUser.code ==
                      "200" &&
                    this.props.receiveGetAddedBankAccountsForUser.result.map(
                      (bankAcc) => (
                        <div className="w-link-btn">
                          <p>{bankAcc.accountDisplayName}</p>
                          <button
                            onClick={this.editAccount}
                            className="edit-btn"
                          >
                            Edit
                          </button>
                        </div>
                      )
                    )}
                </div>
              ) : (
                ""
              )}

              {/* Linked Account for cards */}

              {this.state.transcardCardState == true ? (
                <div className="top-right-head">
                  {this.props.receiveGetAddedCardsForUser &&
                  this.props.receiveGetAddedCardsForUser.code == "200" ? (
                    <div className="w-link-btn bdr-btm-1">
                      {" "}
                      <h3>Linked Card</h3>
                    </div>
                  ) : (
                    ""
                  )}
                  {/* <button className="btn btn-link-acc">
                         Add Another Account
                         </button> */}

                  {this.props.receiveGetAddedCardsForUser &&
                    this.props.receiveGetAddedCardsForUser.code == "200" &&
                    this.props.receiveGetAddedCardsForUser.result.map(
                      (card) => (
                        <div className="w-link-btn">
                          <p>{card.cardNickName}</p>
                          <button onClick={this.editCard} className="edit-btn">
                            Edit
                          </button>
                        </div>
                      )
                    )}
                </div>
              ) : (
                ""
              )}
            </div>
            {/* {walletBalance !=0 ?   */}
            <div>
              {this.state.transcardAccountState == false &&
              this.state.transcardCardState == false &&
              walletBalance == 0 ? (
                <div className="You-can-link-your-ac">
                  You can link your account once funds have been collected in a
                  settlement.
                </div>
              ) : (
                ""
              )}
              {walletBalance != 0 ? (
                <div className="w-table-outer">
                  <h3 className="w-h3">Collected Settlements</h3>
                  <Table className="table-layout">
                    <TableHead>
                      <TableRow>
                        <TableCell className="w-table-name">
                          Settlement Name
                        </TableCell>
                        <TableCell className="w-table-gross">
                          Gross Distribution
                        </TableCell>
                        <TableCell className="w-table-fee">
                          Collectively Fee
                        </TableCell>
                        <TableCell className="w-table-distri">
                          Net Distribution
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    {this.props.receiveGetCollectedSettlementsHistoryForUser
                      .data &&
                      this.props.receiveGetCollectedSettlementsHistoryForUser
                        .data.code == "200" &&
                      this.props.receiveGetCollectedSettlementsHistoryForUser.data.result.records.map(
                        (historySet) => (
                          <TableBody>
                            <TableRow>
                              <TableCell className="table-name">
                                <i className="material-icons t-icon">
                                  play_arrow
                                </i>{" "}
                                {historySet.settlementShortName}
                              </TableCell>
                              <TableCell className="w-text-right">
                                {historySet.priceBreakupDto.totalAmount}
                              </TableCell>
                              <TableCell className="w-text-right">
                                <span className="w-red">
                                  ($
                                  {historySet.priceBreakupDto.collectivelyCommissionAmount.toFixed(
                                    2
                                  )}
                                  ){" "}
                                </span>
                              </TableCell>
                              <TableCell className="w-text-right">
                                $
                                {historySet.priceBreakupDto.userAmount.toFixed(
                                  2
                                )}
                              </TableCell>
                            </TableRow>
                          </TableBody>
                        )
                      )}
                  </Table>
                </div>
              ) : (
                <div>
                  <h3 className="w-h3">Collected Settlements</h3>
                  <p className="No-Payments-Yet">No Settlements Available</p>
                </div>
              )}
              {this.props.receiveGetUserTransactionsHistory &&
              this.props.receiveGetUserTransactionsHistory.data &&
              this.props.receiveGetUserTransactionsHistory.data.code &&
              this.props.receiveGetUserTransactionsHistory.data.code != 404 ? (
                <div className="w-pay-history w-table-outer">
                  <h3 className="w-h3">Payment History</h3>
                  <div className="w-history-table">
                    <Table className="table-layout">
                      <TableHead>
                        <TableRow>
                          <TableCell className="w-table-set">
                            Settlement
                          </TableCell>
                          <TableCell className="w-table-gamount">
                            Gross Amount
                          </TableCell>
                          <TableCell className="w-table-gross">
                            Colletively Fee
                          </TableCell>
                          <TableCell className="w-table-gross">
                            Transfer Fee
                          </TableCell>
                          <TableCell className="w-table-type">Type</TableCell>
                          <TableCell className="w-table-namount">
                            Net Amount
                          </TableCell>
                          <TableCell className="w-table-status">
                            Status
                          </TableCell>
                          <TableCell className="w-table-date">Date</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableRow className="row-coll">
                          <TableCell className="table-name d-col-flex">
                            <span className="t-btn-coll" onClick={this.toggleHandlerOne} style={{cursor: "pointer"}}> {this.state.tableState ? "+" : "-"} </span>{" "}
                            <span className="b-text"> 2021 </span>
                          </TableCell>

                          <TableCell colSpan={7} className="w-text-right">
                            Export ,<span className="b-text"> <DownloadPdfFile datas={this.props.receiveGetUserTransactionsHistory.data}/> / <CSVLink {...csvReport}>CSV</CSVLink></span>
                          </TableCell>
                        </TableRow>
                        {this.props.receiveGetUserTransactionsHistory.data &&
                          this.props.receiveGetUserTransactionsHistory.data
                            .code == "200" &&
                          this.props.receiveGetUserTransactionsHistory.data.result.records.map(
                            (transactionHistory) => (
                              <TableRow>
                                {this.state.tableState ? null :
                                <>
                                <TableCell className="table-name">
                                  <i className="material-icons t-icon">
                                    play_arrow
                                  </i>{" "}
                                  {transactionHistory.settlementShortName}
                                </TableCell>
                                <TableCell className="">
                                  $
                                  {transactionHistory.priceBreakupDto.totalAmount.toFixed(
                                    2
                                  )}
                                </TableCell>
                                <TableCell className="w-text-right">
                                  <span className="w-red">
                                    ($
                                    {transactionHistory.priceBreakupDto.collectivelyCommissionAmount.toFixed(
                                      2
                                    )}
                                    ){" "}
                                  </span>
                                </TableCell>
                                <TableCell className="w-text-right">
                                  <span className="w-red">
                                    ($
                                    {transactionHistory.priceBreakupDto.transferFee.toFixed(
                                      2
                                    )}
                                    ){" "}
                                  </span>
                                </TableCell>
                                <TableCell className="w-text-right">
                                  {transactionHistory.transferMode}
                                </TableCell>
                                <TableCell className="w-text-right">
                                  $
                                  {transactionHistory.priceBreakupDto.userAmount.toFixed(
                                    2
                                  )}
                                </TableCell>
                                <TableCell className="">
                                  {"Completed"}
                                </TableCell>
                                <TableCell className="w-text-right">
                                  {/* 08/27/2020  10:59AM */}
                                  {transactionHistory.amountTransferredDate}
                                </TableCell>
                                </>}
                              </TableRow>
                            )
                          )}
                      </TableBody>
                    </Table>
                  </div>
                </div>
              ) : (
                <div>
                  <h3 className="w-h3">Payment History</h3>{" "}
                  <p className="No-Payments-Yet">No Payments Yet</p>
                </div>
              )}
            </div>
            {/* :  */}
            {/* { this.state.transcardAccountState == false && walletBalance == 0
        ?
        <div className="You-can-link-your-ac">
        You can link your account once funds have been collected in a settlement.
        </div>
        : 
        ""
        } */}
            <div className="w-pby">
              <p>Powered by:</p>
              <img src={transcard} alt="" />
            </div>
          </TabPanel>
        </Tabs>
      </div>
    );
  }
}

Profile.contextTypes = {
  router: PropTypes.object.isRequired,
};
const mapStateToProps = (state) => {
  return {
    data: state.data,
    recieveLinkAccountProfile: state.data.recieveLinkAccountProfile,
    receiveTranscardCardApi: state.data.receiveTranscardCardApi,
    recieveGetTranscardPaymentMethods:
      state.data.recieveGetTranscardPaymentMethods,
    recieveDisburseAmount: state.data.recieveDisburseAmount,
    receiveTransferFundsToACH: state.data.receiveTransferFundsToACH,
    receiveTransferFundsToCard: state.data.receiveTransferFundsToCard,
    receiveAddUserBankAccountApi: state.data.receiveAddUserBankAccountApi,
    receiveAddUserCard: state.data.receiveAddUserCard,
    receiveGetAddedBankAccountsForUser:
      state.data.receiveGetAddedBankAccountsForUser.data,
    receiveGetAddedCardsForUser: state.data.receiveGetAddedCardsForUser.data,
    receiveGetCollectedSettlementsHistoryForUser:
      state.data.receiveGetCollectedSettlementsHistoryForUser,
    receiveGetUserTransactionsHistory:
      state.data.receiveGetUserTransactionsHistory,
    receiveSetDefaultBankAccount: state.data.receiveSetDefaultBankAccount,
    receiveSetDefaultCard: state.data.receiveSetDefaultCard,
    receiveDeleteUserBankAccount: state.data.receiveDeleteUserBankAccount,
    receiveDeleteUserCard: state.data.receiveDeleteUserCard,
    receiveShowNetAmountToUser: state.data.receiveShowNetAmountToUser,
    receiveUpdateBankAccountDetails: state.data.receiveUpdateBankAccountDetails,
    receiveUpdateCardDetails: state.data.receiveUpdateCardDetails,
    receiveGetAllBankAccountsForUser:
      state.data.receiveGetAllBankAccountsForUser,
    receiveGetAllAddedCardsForUser: state.data.receiveGetAllAddedCardsForUser,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getConsumerUser,
      getAllCountry,
      uploadfile,
      updateConsumerUser,
      saveResidences,
      getAllStates,
      getConsumerUserResidenceAction,
      deleteResidencesData,
      viewResidencesData,
      checkEmailVerify,
      clearDataEmail,
      getDebitWalletBalance,
      createTranscardAccount,
      createTranscardCard,
      addUserBankAccount,
      addUserCard,
      getTranscardPaymentMethods,
      disbursePayment,
      transferFundsToACH,
      transferFundsToCard,
      clearReceiveAddUserBankAccountApi,
      clearReceiveAddUserCard,
      getAddedBankAccountsForUser,
      getAddedCardsForUser,
      setDefaultBankAccount,
      setDefaultCard,
      deleteUserBankAccount,
      deleteUserCard,
      getCollectedSettlementsHistoryForUser,
      getUserTransactionsHistory,
      showNetAmountToUser,
      clearRecieveDisburseAmount,
      clearReceiveTransferFundsToACH,
      clearReceiveTransferFundsToCard,
      cleargetDebitWalletBalance,
      updateBankAccountDetails,
      updateCardDetails,
      getAllBankAccountsForUser,
      getAllAddedCardsForUser,
      clearReceiveUpdateBankAccountDetails,
      clearReceiveUpdateCardDetails,
    },
    dispatch
  );

export default withAlert(connect(mapStateToProps, mapDispatchToProps)(Profile));
